var _path, _path2, _path3, _path4, _g, _path5, _path6, _g2, _path7, _path8, _path9, _g3, _path10, _g4, _path11, _g5, _path12, _g6, _path13, _g7, _path14, _g8, _path15, _path16, _path17, _path18, _path19, _path20, _g9, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _g10, _path33, _path34, _g11, _path35, _path36, _path37, _path38, _path39, _path40, _g12, _path41, _g13, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _g14, _path51;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOfferRealtime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 747,
    height: 476,
    viewBox: "0 0 747 476",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_644_4520",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 747,
    height: 476
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M746.522 0H0V475.626H746.522V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_644_4520)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_644_4520",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 747,
    height: 476
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M746.522 0H0V475.626H746.522V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_644_4520)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M741.034 151.623C756.388 54.029 619.425 -2.08605 542.465 0.563946C498.331 2.08395 459.212 21.0639 420.67 40.9229C351.239 76.6909 293.379 78.7949 240.78 56.7029C192.639 36.4839 132.414 43.1669 87.039 68.5159C64 81.3859 43.539 100.093 31.734 123.983C16.894 154.029 30.087 188.712 37.103 219.083C40.537 233.941 43.769 250.089 38.803 264.998C24.069 309.181 1.97697 313.389 5.13297 335.481L8.28897 357.573H736.268C736.268 357.573 753.1 332.325 743.632 293.399C739.232 275.326 727.949 262.367 716.525 248.339C710.682 241.164 705.292 233.312 703.047 224.339C696.676 198.874 718.901 196.622 730.953 180.577C737.094 172.402 739.479 161.494 741.033 151.621",
    fill: "#3561E4"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_644_4520",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 0,
    width: 743,
    height: 358
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M746.522 0.474854H4.82898V357.573H746.522V0.474854Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_644_4520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M741.034 151.623C756.388 54.029 619.425 -2.08605 542.465 0.563946C498.331 2.08395 458.902 20.2139 420.365 40.0699C350.928 75.838 293.379 78.7949 240.78 56.7029C192.639 36.4839 132.414 43.1669 87.039 68.5159C64 81.3859 43.539 100.093 31.734 123.983C16.894 154.029 30.087 188.712 37.103 219.083C40.537 233.941 43.769 250.089 38.803 264.998C24.069 309.181 1.97697 313.389 5.13297 335.481L8.28897 357.573H736.268C736.268 357.573 753.1 332.325 743.632 293.399C739.232 275.326 727.949 262.367 716.525 248.339C710.682 241.164 705.292 233.312 703.047 224.339C696.676 198.874 718.901 196.622 730.953 180.577C737.094 172.402 739.479 161.494 741.033 151.621",
    fill: "white"
  }))))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59802 356.919H735.45",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_644_4520",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 747,
    height: 476
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M746.522 0H0V475.626H746.522V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_644_4520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.59802 475.1H735.45",
    stroke: "#263238",
    strokeMiterlimit: 10
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59802 408.915H735.45",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_644_4520",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 747,
    height: 476
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M746.522 0H0V475.626H746.522V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_644_4520)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.23
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_644_4520",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 741,
    height: 329
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M740.098 0H0V328.621H740.098V0Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_644_4520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.948 323.485V142.787H150.217V326.168",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9609 142.583V135.821H145.95V142.573",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.63 150.339V325.126",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.845 150.339V325.126",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.061 150.339V325.126",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.277 150.339V325.126",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.493 150.339V325.126",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.709 150.339V325.126",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.924 150.339V325.126",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.14 150.339V325.126",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.356 150.339V325.126",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.572 150.339V325.126",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.788 150.339V325.126",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.003 150.339V325.126",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.219 150.339V325.126",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.63 157.724H143.508",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.63 170.197H143.508",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.63 182.67H143.508",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.63 195.143H143.508",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.63 207.616H143.508",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.63 220.089H143.508",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.63 232.562H143.508",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.63 245.035H143.508",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.63 257.508H143.508",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.63 269.981H143.508",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.63 282.454H143.508",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.63 294.927H143.508",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.63 307.4H143.508",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2889 135.739V127.777H93.6379V136.034",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.481 134.427V69.1768H198.812V327.033",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.134 69.187V61.449H193.262V68.732",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.772 60.9938V45.5168H177.624V60.5378",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.203 76.375H150.149V82.596H153.203V76.375Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.364 76.375H159.31V82.596H162.364V76.375Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.525 76.375H168.471V82.596H171.525V76.375Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.686 76.375H177.632V82.596H180.686V76.375Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.847 76.375H186.793V82.596H189.847V76.375Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.203 91.928H150.149V98.151H153.203V91.928Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.364 91.928H159.31V98.151H162.364V91.928Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.525 91.928H168.471V98.151H171.525V91.928Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.686 91.928H177.632V98.151H180.686V91.928Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.847 91.928H186.793V98.151H189.847V91.928Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.203 107.484H150.149V113.705H153.203V107.484Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.364 107.484H159.31V113.705H162.364V107.484Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.525 107.484H168.471V113.705H171.525V107.484Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.686 107.484H177.632V113.705H180.686V107.484Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.847 107.484H186.793V113.705H189.847V107.484Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.203 123.039H150.149V129.262H153.203V123.039Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.364 123.039H159.31V129.262H162.364V123.039Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.525 123.039H168.471V129.262H171.525V123.039Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.686 123.039H177.632V129.262H180.686V123.039Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.847 123.039H186.793V129.262H189.847V123.039Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.364 138.594H159.31V144.817H162.364V138.594Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.525 138.594H168.471V144.817H171.525V138.594Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.686 138.594H177.632V144.817H180.686V138.594Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.847 138.594H186.793V144.817H189.847V138.594Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.364 154.15H159.31V160.373H162.364V154.15Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.525 154.15H168.471V160.373H171.525V154.15Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.686 154.15H177.632V160.373H180.686V154.15Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.847 154.15H186.793V160.373H189.847V154.15Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.364 169.705H159.31V175.926H162.364V169.705Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.525 169.705H168.471V175.926H171.525V169.705Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.686 169.705H177.632V175.926H180.686V169.705Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.847 169.705H186.793V175.926H189.847V169.705Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.364 185.26H159.31V191.483H162.364V185.26Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.525 185.26H168.471V191.483H171.525V185.26Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.686 185.26H177.632V191.483H180.686V185.26Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.847 185.26H186.793V191.483H189.847V185.26Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.364 200.816H159.31V207.037H162.364V200.816Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.525 200.816H168.471V207.037H171.525V200.816Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.686 200.816H177.632V207.037H180.686V200.816Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.847 200.816H186.793V207.037H189.847V200.816Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.364 216.371H159.31V222.594H162.364V216.371Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.525 216.371H168.471V222.594H171.525V216.371Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.686 216.371H177.632V222.594H180.686V216.371Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.847 216.371H186.793V222.594H189.847V216.371Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.364 231.926H159.31V238.149H162.364V231.926Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.525 231.926H168.471V238.149H171.525V231.926Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.686 231.926H177.632V238.149H180.686V231.926Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.847 231.926H186.793V238.149H189.847V231.926Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.364 247.48H159.31V253.703H162.364V247.48Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.525 247.48H168.471V253.703H171.525V247.48Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.686 247.48H177.632V253.703H180.686V247.48Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.847 247.48H186.793V253.703H189.847V247.48Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.364 263.037H159.31V269.258H162.364V263.037Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.525 263.037H168.471V269.258H171.525V263.037Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.686 263.037H177.632V269.258H180.686V263.037Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.847 263.037H186.793V269.258H189.847V263.037Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.364 278.591H159.31V284.814H162.364V278.591Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.525 278.591H168.471V284.814H171.525V278.591Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.686 278.591H177.632V284.814H180.686V278.591Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.847 278.591H186.793V284.814H189.847V278.591Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.364 294.147H159.31V300.37H162.364V294.147Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.525 294.147H168.471V300.37H171.525V294.147Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.686 294.147H177.632V300.37H180.686V294.147Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.847 294.147H186.793V300.37H189.847V294.147Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.364 309.703H159.31V315.924H162.364V309.703Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.525 309.703H168.471V315.924H171.525V309.703Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.686 309.703H177.632V315.924H180.686V309.703Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.847 309.703H186.793V315.924H189.847V309.703Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.775 88.22H324.994V325.846",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.119 93.4358H203.562V106.458H226.119V93.4358Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.187 93.4358H230.63V106.458H253.187V93.4358Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.254 93.4358H257.697V106.458H280.254V93.4358Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.68 123.817H303.979",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.68 132.373H303.979",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.68 140.928H303.979",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.68 149.483H303.979",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.68 158.039H303.979",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.68 166.594H303.979",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.68 175.149H303.979",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.68 183.705H303.979",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.68 192.26H303.979",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.68 200.816H303.979",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.68 209.371H303.979",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.68 217.926H303.979",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.68 226.482H303.979",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.68 235.037H303.979",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.68 243.592H303.979",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.68 252.148H303.979",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.68 260.703H303.979",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.68 269.258H303.979",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.68 277.814H303.979",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.68 286.369H303.979",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.68 294.925H303.979",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.68 303.48H303.979",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.68 312.035H303.979",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.68 320.591H303.979",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.851 123.817H319.249",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.851 132.373H319.249",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.851 140.928H319.249",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.851 149.483H319.249",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.851 158.039H319.249",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.851 166.594H319.249",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.851 175.149H319.249",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.851 183.705H319.249",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.851 192.26H319.249",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.851 200.816H319.249",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.851 209.371H319.249",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.851 217.926H319.249",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.851 226.482H319.249",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.851 235.037H319.249",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.851 243.592H319.249",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.851 252.148H319.249",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.851 260.703H319.249",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.851 269.258H319.249",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.851 277.814H319.249",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.851 286.369H319.249",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.851 294.925H319.249",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.851 303.48H319.249",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.851 312.035H319.249",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.851 320.591H319.249",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.588 88.361V83.931H238.407V81.438H254.987V86.425H278.637V88.086",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.994 88.2199V0.525879H381.335V86.0979H443.654V328.098",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.238 27.21H426.492V86.099",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.304 7.88696V326.255",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.318 11.4978H338.716",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.318 20.054H338.716",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.318 28.6089H338.716",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.318 37.1648H338.716",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.318 45.72H338.716",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.318 54.2749H338.716",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.318 62.8308H338.716",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.318 71.386H338.716",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.318 79.9409H338.716",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.318 88.4968H338.716",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.318 97.0518H338.716",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.318 105.608H338.716",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.318 114.163H338.716",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.318 122.718H338.716",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.318 131.274H338.716",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.318 139.829H338.716",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.318 148.384H338.716",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.318 156.94H338.716",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.318 165.495H338.716",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.318 174.051H338.716",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.318 182.606H338.716",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.318 191.161H338.716",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.318 199.717H338.716",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.318 208.272H338.716",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.318 215.889H338.716",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.318 224.445H338.716",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.318 233H338.716",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.318 241.556H338.716",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.318 250.111H338.716",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.318 258.666H338.716",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.318 267.222H338.716",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.318 275.777H338.716",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.318 284.332H338.716",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.318 291.734H338.716",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.318 300.289H338.716",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.318 308.845H338.716",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.318 317.4H338.716",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.318 325.955H338.716",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.605 11.4978H358.003",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.605 20.054H358.003",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.605 28.6089H358.003",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.605 37.1648H358.003",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.605 45.72H358.003",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.605 54.2749H358.003",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.605 62.8308H358.003",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.605 71.386H358.003",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.605 79.9409H358.003",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.605 88.4968H358.003",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.605 97.0518H358.003",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.605 105.608H358.003",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.605 114.163H358.003",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.605 122.718H358.003",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.605 131.274H358.003",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.605 139.829H358.003",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.605 148.384H358.003",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.605 156.94H358.003",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.605 165.495H358.003",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.605 174.051H358.003",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.605 182.606H358.003",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.605 191.161H358.003",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.605 199.717H358.003",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.605 208.272H358.003",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.605 215.889H358.003",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.605 224.445H358.003",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.605 233H358.003",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.605 241.556H358.003",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.605 250.111H358.003",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.605 258.666H358.003",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.605 267.222H358.003",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.605 275.777H358.003",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.605 284.332H358.003",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.159 11.4978H373.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.159 20.054H373.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.159 28.6089H373.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.159 37.1648H373.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.159 45.72H373.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.159 54.2749H373.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.159 62.8308H373.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.159 71.386H373.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.159 79.9409H373.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.159 88.4968H373.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.159 97.0518H373.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.159 105.608H373.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.159 114.163H373.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.159 122.718H373.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.159 131.274H373.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.159 139.829H373.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.159 148.384H373.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.159 156.94H373.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.159 165.495H373.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.159 174.051H373.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.159 182.606H373.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.159 191.161H373.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.159 199.717H373.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.159 208.272H373.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.159 215.889H373.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.159 224.445H373.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.159 233H373.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.159 241.556H373.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.159 250.111H373.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.159 258.666H373.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.159 267.222H373.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.159 275.777H373.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.159 284.332H373.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.713 97.0518H389.111",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.713 105.608H389.111",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.713 114.163H389.111",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.713 122.718H389.111",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.713 131.274H389.111",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.713 139.829H389.111",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.713 148.384H389.111",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.713 156.94H389.111",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.713 165.495H389.111",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.713 174.051H389.111",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.713 182.606H389.111",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.713 191.161H389.111",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.713 199.717H389.111",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.713 208.272H389.111",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.713 215.889H389.111",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.713 224.445H389.111",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.713 233H389.111",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.713 241.556H389.111",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.713 250.111H389.111",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.713 258.666H389.111",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.713 267.222H389.111",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.713 275.777H389.111",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.713 284.332H389.111",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.267 97.0518H404.665",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.267 105.608H404.665",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.267 114.163H404.665",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.267 122.718H404.665",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.267 131.274H404.665",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.267 139.829H404.665",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.267 148.384H404.665",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.267 156.94H404.665",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.267 165.495H404.665",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.267 174.051H404.665",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.267 182.606H404.665",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.267 191.161H404.665",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.267 199.717H404.665",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.267 208.272H404.665",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.267 215.889H404.665",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.267 224.445H404.665",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.267 233H404.665",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.267 241.556H404.665",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.267 250.111H404.665",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.267 258.666H404.665",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.267 267.222H404.665",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.267 275.777H404.665",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.267 284.332H404.665",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.821 97.0518H420.219",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.821 105.608H420.219",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.821 114.163H420.219",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.821 122.718H420.219",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.821 131.274H420.219",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.821 139.829H420.219",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.821 148.384H420.219",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.821 156.94H420.219",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.821 165.495H420.219",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.821 174.051H420.219",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.821 182.606H420.219",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.821 191.161H420.219",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.821 199.717H420.219",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.821 208.272H420.219",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.821 215.889H420.219",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.821 224.445H420.219",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.821 233H420.219",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.821 241.556H420.219",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.821 250.111H420.219",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.821 258.666H420.219",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.821 267.222H420.219",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.821 275.777H420.219",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.821 284.332H420.219",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.375 97.0518H435.773",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.375 105.608H435.773",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.375 114.163H435.773",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.375 122.718H435.773",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.375 131.274H435.773",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.375 139.829H435.773",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.375 148.384H435.773",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.375 156.94H435.773",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.375 165.495H435.773",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.375 174.051H435.773",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.375 182.606H435.773",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.375 191.161H435.773",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.375 199.717H435.773",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.375 208.272H435.773",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.375 215.889H435.773",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.375 224.445H435.773",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.375 233H435.773",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.375 241.556H435.773",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.375 250.111H435.773",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.375 258.666H435.773",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.375 267.222H435.773",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.375 275.777H435.773",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.375 284.332H435.773",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.605 291.734H358.003",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.605 300.289H358.003",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.605 308.845H358.003",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.605 317.4H358.003",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.605 325.955H358.003",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.159 291.734H373.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.159 300.289H373.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.159 308.845H373.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.159 317.4H373.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.159 325.955H373.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.713 291.734H389.111",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.713 300.289H389.111",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.713 308.845H389.111",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.713 317.4H389.111",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.713 325.955H389.111",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.267 291.734H404.665",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.267 300.289H404.665",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.267 308.845H404.665",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.267 317.4H404.665",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.267 325.955H404.665",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.821 291.734H420.219",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.821 300.289H420.219",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.821 308.845H420.219",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.821 317.4H420.219",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.821 325.955H420.219",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.375 291.734H435.773",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.375 300.289H435.773",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.375 308.845H435.773",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.375 317.4H435.773",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.375 325.955H435.773",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.326 115.383H105.472V93.1078H41.626V64.5928H21.516V131.417H0.526001",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.434 65.4879H445.676V47.6689H489.404V121.696",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.525 323.485V142.787H564.795V326.168",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.538 142.583V135.821H560.527V142.573",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.207 150.339V325.126",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.423 150.339V325.126",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.639 150.339V325.126",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.855 150.339V325.126",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.07 150.339V325.126",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.286 150.339V325.126",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.502 150.339V325.126",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.718 150.339V325.126",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.933 150.339V325.126",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.149 150.339V325.126",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.365 150.339V325.126",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.581 150.339V325.126",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.797 150.339V325.126",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.207 157.724H558.085",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.207 170.197H558.085",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.207 182.67H558.085",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.207 195.143H558.085",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.207 207.616H558.085",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.207 220.089H558.085",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.207 232.562H558.085",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.207 245.035H558.085",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.207 257.508H558.085",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.207 269.981H558.085",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.207 282.454H558.085",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.207 294.927H558.085",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.207 307.4H558.085",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.866 135.739V127.777H508.21V136.034",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.058 134.427V69.1768H613.389V327.033",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.711 69.187V61.449H607.839V68.732",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.35 60.9938V45.5168H592.202V60.5378",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.78 76.375H564.726V82.596H567.78V76.375Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.942 76.375H573.888V82.596H576.942V76.375Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.102 76.375H583.048V82.596H586.102V76.375Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.264 76.375H592.21V82.596H595.264V76.375Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.425 76.375H601.371V82.596H604.425V76.375Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.78 91.928H564.726V98.151H567.78V91.928Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.942 91.928H573.888V98.151H576.942V91.928Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.102 91.928H583.048V98.151H586.102V91.928Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.264 91.928H592.21V98.151H595.264V91.928Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.425 91.928H601.371V98.151H604.425V91.928Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.78 107.484H564.726V113.705H567.78V107.484Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.942 107.484H573.888V113.705H576.942V107.484Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.102 107.484H583.048V113.705H586.102V107.484Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.264 107.484H592.21V113.705H595.264V107.484Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.425 107.484H601.371V113.705H604.425V107.484Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.78 123.039H564.726V129.262H567.78V123.039Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.942 123.039H573.888V129.262H576.942V123.039Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.102 123.039H583.048V129.262H586.102V123.039Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.264 123.039H592.21V129.262H595.264V123.039Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.425 123.039H601.371V129.262H604.425V123.039Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.942 138.594H573.888V144.817H576.942V138.594Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.102 138.594H583.048V144.817H586.102V138.594Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.264 138.594H592.21V144.817H595.264V138.594Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.425 138.594H601.371V144.817H604.425V138.594Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.942 154.15H573.888V160.373H576.942V154.15Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.102 154.15H583.048V160.373H586.102V154.15Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.264 154.15H592.21V160.373H595.264V154.15Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.425 154.15H601.371V160.373H604.425V154.15Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.942 169.705H573.888V175.926H576.942V169.705Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.102 169.705H583.048V175.926H586.102V169.705Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.264 169.705H592.21V175.926H595.264V169.705Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.425 169.705H601.371V175.926H604.425V169.705Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.942 185.26H573.888V191.483H576.942V185.26Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.102 185.26H583.048V191.483H586.102V185.26Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.264 185.26H592.21V191.483H595.264V185.26Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.425 185.26H601.371V191.483H604.425V185.26Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.942 200.816H573.888V207.037H576.942V200.816Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.102 200.816H583.048V207.037H586.102V200.816Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.264 200.816H592.21V207.037H595.264V200.816Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.425 200.816H601.371V207.037H604.425V200.816Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.942 216.371H573.888V222.594H576.942V216.371Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.102 216.371H583.048V222.594H586.102V216.371Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.264 216.371H592.21V222.594H595.264V216.371Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.425 216.371H601.371V222.594H604.425V216.371Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.942 231.926H573.888V238.149H576.942V231.926Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.102 231.926H583.048V238.149H586.102V231.926Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.264 231.926H592.21V238.149H595.264V231.926Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.425 231.926H601.371V238.149H604.425V231.926Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.942 247.48H573.888V253.703H576.942V247.48Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.102 247.48H583.048V253.703H586.102V247.48Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.264 247.48H592.21V253.703H595.264V247.48Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.425 247.48H601.371V253.703H604.425V247.48Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.942 263.037H573.888V269.258H576.942V263.037Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.102 263.037H583.048V269.258H586.102V263.037Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.264 263.037H592.21V269.258H595.264V263.037Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.425 263.037H601.371V269.258H604.425V263.037Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.942 278.591H573.888V284.814H576.942V278.591Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.102 278.591H583.048V284.814H586.102V278.591Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.264 278.591H592.21V284.814H595.264V278.591Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.425 278.591H601.371V284.814H604.425V278.591Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.942 294.147H573.888V300.37H576.942V294.147Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.102 294.147H583.048V300.37H586.102V294.147Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.264 294.147H592.21V300.37H595.264V294.147Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.425 294.147H601.371V300.37H604.425V294.147Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.942 309.703H573.888V315.924H576.942V309.703Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.102 309.703H583.048V315.924H586.102V309.703Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.264 309.703H592.21V315.924H595.264V309.703Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.425 309.703H601.371V315.924H604.425V309.703Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.353 88.22H739.572V325.846",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.696 93.4358H618.139V106.458H640.696V93.4358Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.763 93.4358H645.206V106.458H667.763V93.4358Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.832 93.4358H672.275V106.458H694.832V93.4358Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.258 123.817H718.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.258 132.373H718.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.258 140.928H718.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.258 149.483H718.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.258 158.039H718.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.258 166.594H718.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.258 175.149H718.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.258 183.705H718.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.258 192.26H718.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.258 200.816H718.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.258 209.371H718.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.258 217.926H718.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.258 226.482H718.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.258 235.037H718.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.258 243.592H718.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.258 252.148H718.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.258 260.703H718.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.258 269.258H718.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.258 277.814H718.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.258 286.369H718.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.258 294.925H718.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.258 303.48H718.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.258 312.035H718.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.258 320.591H718.557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.428 123.817H733.826",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.428 132.373H733.826",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.428 140.928H733.826",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.428 149.483H733.826",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.428 158.039H733.826",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.428 166.594H733.826",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.428 175.149H733.826",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.428 183.705H733.826",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.428 192.26H733.826",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.428 200.816H733.826",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.428 209.371H733.826",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.428 217.926H733.826",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.428 226.482H733.826",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.428 235.037H733.826",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.428 243.592H733.826",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.428 252.148H733.826",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.428 260.703H733.826",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.428 269.258H733.826",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.428 277.814H733.826",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.428 286.369H733.826",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.428 294.925H733.826",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.428 303.48H733.826",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.428 312.035H733.826",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.428 320.591H733.826",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.166 88.361V83.931H652.987V81.438H669.567V86.425H693.214V88.086",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.906 115.383H520.049V93.1079H491.231",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.593 55.5708V122.954",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.031 55.5708V122.954",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.469 55.5708V122.954",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_644_4520",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 747,
    height: 476
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M746.522 0H0V475.626H746.522V0Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_644_4520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.652 431.147C25.5541 431.513 27.506 431.539 29.417 431.222C29.394 432.391 29.404 433.622 29.5 434.901C29.6162 436.772 29.8987 438.628 30.344 440.449C30.349 440.47 30.359 440.492 30.363 440.513C30.05 440.003 29.124 438.606 29.041 438.506C27.868 437.106 24.778 435.093 22.884 435.863C22.573 436 22.2943 436.2 22.0659 436.452C21.8375 436.703 21.6646 437 21.5584 437.323C21.4522 437.645 21.4151 437.987 21.4495 438.325C21.4839 438.662 21.589 438.989 21.758 439.284C22.1783 439.887 22.7252 440.392 23.3604 440.762C23.9956 441.132 24.7039 441.36 25.436 441.428C26.955 441.674 30.173 440.795 30.429 440.728C30.927 442.569 31.5481 444.375 32.288 446.133C32.713 447.16 33.173 448.181 33.647 449.199C33.362 448.767 33.103 448.383 33.062 448.332C31.887 446.932 28.797 444.919 26.903 445.689C26.592 445.826 26.3132 446.026 26.0849 446.278C25.8565 446.529 25.6837 446.826 25.5775 447.149C25.4714 447.471 25.4344 447.813 25.469 448.151C25.5035 448.489 25.6088 448.815 25.778 449.11C26.1983 449.713 26.745 450.217 27.38 450.588C28.015 450.958 28.7231 451.186 29.455 451.255C31.0973 451.282 32.734 451.056 34.308 450.587C34.493 450.975 34.674 451.366 34.863 451.754C35.763 453.615 36.663 455.469 37.498 457.313C37.793 457.963 38.057 458.613 38.326 459.264C38.07 458.88 37.854 458.564 37.816 458.514C36.642 457.114 33.552 455.101 31.658 455.871C31.347 456.008 31.0682 456.208 30.8399 456.46C30.6115 456.711 30.4386 457.008 30.3325 457.331C30.2264 457.653 30.1894 457.995 30.224 458.333C30.2585 458.671 30.3638 458.997 30.533 459.292C30.953 459.895 31.4997 460.4 32.1347 460.77C32.7698 461.14 33.478 461.368 34.21 461.436C35.8072 461.47 37.4001 461.256 38.932 460.803C39.184 461.477 39.441 462.152 39.657 462.817C39.794 463.275 39.957 463.705 40.069 464.172C40.181 464.639 40.31 465.087 40.428 465.539C40.628 466.416 40.828 467.32 41.002 468.18C41.125 468.78 41.23 469.35 41.339 469.924C41.055 469.274 40.47 468.013 40.409 467.913C39.461 466.352 36.709 463.893 34.724 464.368C34.3957 464.456 34.0896 464.612 33.8256 464.826C33.5616 465.04 33.3456 465.307 33.1916 465.61C33.0377 465.913 32.9492 466.245 32.9321 466.584C32.9149 466.924 32.9694 467.263 33.092 467.58C33.4164 468.24 33.8808 468.821 34.4528 469.283C35.0247 469.746 35.6906 470.077 36.404 470.256C37.832 470.717 41.017 470.364 41.416 470.318C41.592 471.271 41.753 472.199 41.892 473.077C42 473.745 42.092 474.385 42.184 475.002L43.459 475.022C43.3463 474.337 43.2227 473.621 43.088 472.873C42.913 471.905 42.706 470.873 42.488 469.817C43.4509 469.449 44.3912 469.024 45.304 468.545C46.5193 469.623 47.877 470.528 49.339 471.236C48.96 472.128 48.583 472.992 48.214 473.801C48.014 474.245 47.814 474.67 47.622 475.087L48.97 475.107C49.087 474.839 49.205 474.569 49.325 474.291C49.712 473.391 50.11 472.413 50.508 471.41C50.891 471.496 54.029 472.183 55.5 471.875C56.228 471.772 56.9248 471.512 57.542 471.113C58.1592 470.713 58.682 470.184 59.074 469.562C59.2293 469.26 59.3192 468.928 59.3379 468.589C59.3566 468.25 59.3037 467.911 59.1826 467.593C59.0615 467.276 58.8749 466.987 58.6349 466.747C58.395 466.506 58.1071 466.319 57.79 466.197C55.863 465.516 52.87 467.672 51.763 469.125C51.697 469.21 51.094 470.219 50.722 470.862C50.883 470.452 51.044 470.054 51.204 469.629C51.526 468.791 51.824 467.945 52.147 467.035C52.287 466.591 52.43 466.142 52.572 465.688C52.714 465.234 52.827 464.75 52.958 464.277C53.238 463.177 53.469 462.043 53.675 460.898C55.1819 461.526 56.7766 461.919 58.403 462.062C59.138 462.071 59.866 461.919 60.5364 461.618C61.2068 461.316 61.8035 460.872 62.285 460.317C62.4844 460.042 62.6236 459.728 62.6936 459.396C62.7637 459.063 62.7629 458.72 62.6914 458.387C62.6199 458.055 62.4793 457.742 62.2786 457.468C62.078 457.194 61.8219 456.965 61.527 456.796C59.727 455.831 56.44 457.508 55.127 458.777C55.046 458.856 54.205 459.877 53.755 460.439C53.873 459.75 53.997 459.062 54.093 458.361C54.377 456.337 54.6 454.28 54.832 452.229C54.904 451.601 54.98 450.976 55.057 450.349C55.317 450.449 58.411 451.659 59.944 451.575C60.679 451.584 61.407 451.432 62.0774 451.131C62.7478 450.829 63.3445 450.385 63.826 449.83C64.0274 449.554 64.1681 449.238 64.2388 448.904C64.3095 448.57 64.3086 448.224 64.2361 447.89C64.1637 447.556 64.0213 447.242 63.8184 446.967C63.6155 446.692 63.3567 446.463 63.059 446.295C61.259 445.329 57.972 447.007 56.659 448.276C56.559 448.376 55.353 449.835 55.065 450.222C55.231 448.843 55.411 447.47 55.644 446.122C55.9464 444.303 56.3673 442.505 56.904 440.74C57.025 440.787 60.249 442.061 61.819 441.976C62.554 441.984 63.2821 441.833 63.9525 441.531C64.6229 441.23 65.2196 440.786 65.701 440.23C65.9004 439.955 66.0396 439.641 66.1096 439.309C66.1797 438.976 66.1789 438.633 66.1074 438.3C66.0359 437.968 65.8953 437.655 65.6946 437.381C65.494 437.107 65.2379 436.878 64.943 436.709C63.143 435.744 59.856 437.421 58.543 438.69C58.457 438.773 57.535 439.89 57.11 440.427L57.01 440.372C57.5978 438.611 58.3417 436.906 59.233 435.277C59.713 434.377 60.221 433.538 60.733 432.735C62.1846 433.54 63.7512 434.118 65.378 434.449C66.1078 434.539 66.8483 434.468 67.548 434.242C68.2476 434.016 68.8896 433.64 69.429 433.14C69.6573 432.888 69.8301 432.592 69.9361 432.269C70.0421 431.946 70.0789 431.605 70.0442 431.267C70.0095 430.929 69.904 430.602 69.7346 430.308C69.5652 430.013 69.3357 429.758 69.061 429.558C67.375 428.401 63.926 429.707 62.481 430.824C62.426 430.866 62.062 431.214 61.669 431.597C61.669 431.512 61.677 431.413 61.681 431.297C61.74 431.21 61.798 431.119 61.856 431.036C62.731 429.761 63.612 428.647 64.399 427.666C64.851 427.113 65.271 426.621 65.669 426.166C67.3204 426.211 68.9689 426.002 70.557 425.547C71.2457 425.29 71.8701 424.885 72.3868 424.362C72.9035 423.839 73.3001 423.21 73.549 422.518C73.6356 422.19 73.6522 421.846 73.5974 421.511C73.5427 421.176 73.418 420.856 73.2314 420.572C73.0448 420.288 72.8006 420.046 72.5145 419.863C72.2284 419.68 71.9069 419.559 71.571 419.508C69.541 419.258 67.082 422.008 66.314 423.663C66.248 423.806 65.466 426.163 65.504 426.163H65.547C65.156 426.594 64.74 427.063 64.297 427.58C63.497 428.539 62.591 429.63 61.689 430.88C61.703 428.914 61.418 424.824 58.827 424.536C55.406 424.157 54.367 428.058 56.455 430.212C57.0487 430.783 57.7492 431.231 58.5164 431.531C59.2836 431.831 60.1024 431.977 60.926 431.96C60.254 432.93 59.577 433.974 58.943 435.108C58.0082 436.732 57.2198 438.436 56.587 440.2C56.58 440.221 56.575 440.244 56.568 440.265C56.587 439.665 56.587 437.99 56.568 437.865C56.362 436.05 54.895 432.665 52.891 432.265C52.555 432.207 52.2104 432.22 51.8798 432.304C51.5492 432.388 51.2401 432.541 50.9727 432.752C50.7053 432.964 50.4857 433.23 50.3282 433.533C50.1708 433.835 50.079 434.168 50.059 434.508C50.0764 435.243 50.254 435.965 50.5794 436.625C50.9048 437.284 51.3701 437.864 51.943 438.325C53.074 439.368 56.243 440.409 56.495 440.491C55.8939 442.302 55.4141 444.15 55.059 446.025C54.848 447.115 54.668 448.225 54.502 449.331C54.502 448.812 54.502 448.35 54.49 448.284C54.283 446.469 52.817 443.084 50.813 442.684C50.4781 442.626 50.1348 442.64 49.8054 442.723C49.4761 442.807 49.168 442.959 48.9012 443.169C48.6345 443.38 48.415 443.644 48.2572 443.945C48.0993 444.246 48.0066 444.577 47.985 444.916C48.0034 445.651 48.1815 446.373 48.507 447.033C48.8325 447.692 49.2976 448.273 49.87 448.734C51.224 449.662 52.7127 450.377 54.284 450.853C54.225 451.28 54.161 451.705 54.104 452.132C53.826 454.18 53.56 456.226 53.237 458.224C53.122 458.924 52.985 459.617 52.85 460.307C52.85 459.847 52.845 459.459 52.838 459.4C52.631 457.586 51.164 454.2 49.16 453.8C48.8251 453.742 48.4818 453.756 48.1525 453.84C47.8232 453.923 47.5152 454.075 47.2485 454.286C46.9819 454.497 46.7625 454.761 46.6048 455.062C46.4471 455.363 46.3545 455.694 46.333 456.033C46.3514 456.768 46.5295 457.49 46.8548 458.149C47.1802 458.808 47.645 459.388 48.217 459.85C49.5306 460.76 50.9775 461.46 52.506 461.926C52.345 462.626 52.185 463.333 51.999 464.006C51.862 464.464 51.76 464.913 51.599 465.364C51.438 465.815 51.299 466.264 51.145 466.702C50.824 467.542 50.5 468.409 50.167 469.22C49.94 469.786 49.713 470.32 49.485 470.861C49.608 470.161 49.815 468.786 49.821 468.67C49.8228 467.063 49.4127 465.483 48.63 464.08C48.639 463.901 48.6306 463.722 48.605 463.545C48.5682 463.207 48.4606 462.881 48.2893 462.588C48.118 462.294 47.8867 462.04 47.6107 461.842C47.3347 461.644 47.02 461.506 46.6871 461.438C46.3543 461.369 46.0108 461.372 45.679 461.445C43.694 461.945 42.387 465.39 42.266 467.212C42.259 467.319 42.31 468.494 42.355 469.235C42.262 468.804 42.178 468.384 42.076 467.941C41.882 467.064 41.663 466.195 41.43 465.257C41.303 464.809 41.172 464.357 41.042 463.899C40.912 463.441 40.742 462.976 40.586 462.509C40.213 461.435 39.779 460.364 39.322 459.295C40.925 458.988 42.4711 458.435 43.906 457.657C44.5244 457.259 45.0485 456.73 45.4418 456.108C45.835 455.487 46.088 454.787 46.183 454.057C46.197 453.718 46.1395 453.379 46.0142 453.064C45.8889 452.748 45.6986 452.462 45.4557 452.225C45.2128 451.987 44.9227 451.804 44.6042 451.686C44.2857 451.568 43.9459 451.518 43.607 451.54C41.57 451.729 39.757 454.94 39.36 456.724C39.335 456.834 39.195 458.145 39.133 458.868C38.851 458.227 38.573 457.587 38.268 456.948C37.389 455.104 36.44 453.265 35.502 451.426C35.213 450.863 34.934 450.298 34.651 449.734C34.925 449.676 38.171 448.975 39.403 448.06C40.0214 447.662 40.5453 447.133 40.9383 446.511C41.3312 445.89 41.5837 445.19 41.678 444.46C41.6923 444.121 41.6351 443.782 41.51 443.467C41.3849 443.151 41.1949 442.865 40.9521 442.628C40.7093 442.39 40.4193 442.207 40.1009 442.089C39.7825 441.971 39.4428 441.921 39.104 441.943C37.066 442.132 35.254 445.343 34.856 447.126C34.827 447.26 34.627 449.147 34.599 449.626C33.977 448.385 33.37 447.14 32.821 445.889C32.0699 444.205 31.4295 442.473 30.904 440.705C31.031 440.678 34.423 439.961 35.684 439.024C36.3023 438.626 36.8262 438.097 37.2191 437.475C37.612 436.853 37.8645 436.153 37.959 435.424C37.9733 435.085 37.9161 434.746 37.7909 434.43C37.6658 434.115 37.4756 433.829 37.2327 433.591C36.9899 433.354 36.6997 433.17 36.3812 433.052C36.0627 432.934 35.7229 432.885 35.384 432.907C33.347 433.096 31.534 436.307 31.137 438.09C31.111 438.208 30.957 439.646 30.9 440.331L30.784 440.342C30.3023 438.549 29.9824 436.716 29.828 434.865C29.728 433.848 29.692 432.865 29.678 431.917C31.3327 431.787 32.9579 431.405 34.497 430.784C35.1549 430.456 35.7334 429.988 36.1923 429.414C36.6511 428.84 36.9793 428.172 37.154 427.458C37.2054 427.122 37.1856 426.779 37.0958 426.452C37.006 426.124 36.8483 425.819 36.6329 425.556C36.4174 425.294 36.1492 425.079 35.8454 424.927C35.5417 424.775 35.2094 424.688 34.87 424.673C32.826 424.637 30.67 427.63 30.08 429.359C30.047 429.453 29.828 430.445 29.68 431.168C29.68 430.739 29.672 430.295 29.68 429.884C29.706 428.338 29.826 426.923 29.942 425.672C30.014 424.96 30.093 424.318 30.173 423.719C31.5738 422.844 32.833 421.761 33.907 420.506C34.3398 419.912 34.6379 419.23 34.7804 418.509C34.9229 417.788 34.9064 417.044 34.732 416.33C34.6231 416.008 34.4477 415.713 34.2172 415.464C33.9867 415.214 33.7062 415.016 33.3941 414.882C33.082 414.748 32.7452 414.681 32.4056 414.686C32.066 414.691 31.7312 414.767 31.423 414.91C29.59 415.821 29.057 419.47 29.33 421.277C29.354 421.433 30.003 423.831 30.03 423.81L30.067 423.786C29.978 424.361 29.889 424.98 29.806 425.656C29.662 426.908 29.511 428.324 29.451 429.876C29.438 430.161 29.431 430.455 29.422 430.748C28.661 429.535 26.254 426.129 23.588 426.803C20.356 427.619 21.056 430.479 23.646 431.137",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.073 446.372C93.3218 446.612 94.6034 446.629 95.858 446.421C95.842 447.188 95.85 447.996 95.913 448.835C95.9887 450.063 96.1737 451.282 96.466 452.477C96.466 452.491 96.475 452.505 96.479 452.519C96.274 452.184 95.666 451.267 95.611 451.202C94.841 450.284 92.811 448.961 91.569 449.467C91.3648 449.557 91.1817 449.688 91.0318 449.854C90.8819 450.019 90.7684 450.214 90.6988 450.425C90.6291 450.637 90.6049 450.861 90.6277 451.083C90.6505 451.305 90.7198 451.52 90.831 451.713C91.1067 452.109 91.4654 452.44 91.8822 452.683C92.2989 452.926 92.7636 453.076 93.244 453.121C94.3534 453.132 95.458 452.976 96.521 452.658C96.8485 453.866 97.2564 455.051 97.742 456.205C98.021 456.879 98.323 457.549 98.634 458.217C98.447 457.934 98.276 457.682 98.249 457.649C97.479 456.73 95.449 455.408 94.207 455.913C94.0028 456.003 93.8198 456.134 93.6698 456.3C93.5199 456.465 93.4063 456.659 93.3365 456.871C93.2667 457.083 93.2423 457.307 93.2647 457.529C93.2872 457.751 93.3561 457.966 93.467 458.159C93.7428 458.555 94.1017 458.886 94.5186 459.129C94.9355 459.373 95.4005 459.522 95.881 459.567C96.9588 459.585 98.033 459.437 99.066 459.129C99.188 459.384 99.307 459.64 99.43 459.895C100.02 461.116 100.615 462.332 101.161 463.544C101.354 463.97 101.528 464.397 101.704 464.824C101.537 464.573 101.395 464.361 101.369 464.332C100.599 463.414 98.569 462.091 97.327 462.597C97.1228 462.687 96.9397 462.818 96.7898 462.984C96.6399 463.149 96.5264 463.343 96.4568 463.555C96.3871 463.767 96.3629 463.991 96.3857 464.213C96.4085 464.435 96.4778 464.65 96.589 464.843C96.8647 465.239 97.2234 465.57 97.6402 465.813C98.0569 466.056 98.5216 466.206 99.002 466.251C100.051 466.273 101.096 466.132 102.102 465.834C102.268 466.277 102.437 466.72 102.579 467.156C102.668 467.456 102.779 467.739 102.85 468.045C102.921 468.351 103.008 468.645 103.086 468.945C103.214 469.52 103.351 470.114 103.463 470.679C103.543 471.071 103.612 471.446 103.684 471.824C103.497 471.398 103.114 470.569 103.074 470.504C102.451 469.479 100.647 467.866 99.34 468.177C99.1246 468.235 98.9239 468.337 98.7507 468.478C98.5776 468.618 98.436 468.794 98.335 468.993C98.2341 469.191 98.1762 469.409 98.165 469.632C98.1538 469.855 98.1895 470.077 98.27 470.285C98.4828 470.718 98.7873 471.099 99.1624 471.403C99.5375 471.706 99.9741 471.924 100.442 472.042C101.531 472.222 102.64 472.236 103.733 472.083C103.849 472.708 103.955 473.318 104.046 473.895C104.113 474.332 104.176 474.753 104.237 475.158L105.074 475.171C104.999 474.722 104.918 474.251 104.829 473.76C104.714 473.125 104.579 472.448 104.429 471.754C105.061 471.512 105.678 471.234 106.277 470.919C107.075 471.627 107.966 472.221 108.926 472.686C108.678 473.271 108.426 473.838 108.188 474.369C108.056 474.66 107.928 474.939 107.8 475.213L108.685 475.227C108.762 475.05 108.839 474.874 108.916 474.69C109.172 474.097 109.433 473.457 109.693 472.798C110.764 473.065 111.869 473.168 112.971 473.104C113.449 473.036 113.906 472.865 114.311 472.603C114.716 472.341 115.059 471.993 115.316 471.585C115.418 471.387 115.477 471.169 115.489 470.946C115.501 470.724 115.467 470.501 115.387 470.293C115.308 470.084 115.185 469.895 115.028 469.737C114.87 469.579 114.681 469.456 114.473 469.376C113.207 468.929 111.242 470.344 110.516 471.298C110.473 471.354 110.076 472.017 109.832 472.438C109.938 472.168 110.043 471.908 110.149 471.628C110.36 471.078 110.555 470.522 110.768 469.928C110.86 469.636 110.953 469.341 111.047 469.043C111.141 468.745 111.214 468.428 111.301 468.117C111.485 467.393 111.637 466.651 111.772 465.899C112.76 466.311 113.806 466.568 114.872 466.663C115.355 466.669 115.833 466.569 116.273 466.371C116.713 466.173 117.104 465.881 117.42 465.516C117.551 465.335 117.642 465.129 117.688 464.911C117.733 464.693 117.733 464.467 117.685 464.249C117.638 464.031 117.546 463.825 117.414 463.646C117.282 463.466 117.114 463.316 116.92 463.205C115.737 462.572 113.58 463.673 112.72 464.505C112.666 464.558 112.12 465.225 111.82 465.596C111.898 465.144 111.979 464.696 112.043 464.233C112.228 462.905 112.375 461.555 112.527 460.208C112.573 459.796 112.627 459.385 112.674 458.974C113.698 459.4 114.779 459.67 115.883 459.774C116.366 459.779 116.843 459.68 117.283 459.482C117.723 459.283 118.115 458.992 118.431 458.627C118.562 458.446 118.653 458.24 118.699 458.022C118.744 457.804 118.744 457.578 118.696 457.36C118.649 457.142 118.557 456.936 118.425 456.757C118.293 456.577 118.125 456.427 117.931 456.316C116.748 455.683 114.591 456.784 113.731 457.616C113.666 457.679 112.874 458.64 112.684 458.894C112.793 457.988 112.911 457.088 113.064 456.204C113.263 455.009 113.54 453.829 113.892 452.67C114.921 453.099 116.008 453.373 117.118 453.482C117.601 453.488 118.078 453.388 118.519 453.19C118.959 452.992 119.35 452.7 119.666 452.335C119.797 452.154 119.888 451.948 119.934 451.73C119.98 451.512 119.979 451.286 119.932 451.068C119.885 450.85 119.792 450.644 119.66 450.464C119.528 450.285 119.36 450.135 119.166 450.024C117.983 449.391 115.827 450.492 114.966 451.324C114.909 451.379 114.305 452.11 114.026 452.464L113.959 452.428C114.344 451.272 114.833 450.153 115.418 449.084C115.733 448.491 116.066 447.943 116.403 447.416C117.356 447.944 118.385 448.324 119.453 448.541C119.932 448.6 120.418 448.553 120.877 448.405C121.336 448.257 121.757 448.011 122.111 447.683C122.261 447.518 122.375 447.323 122.444 447.111C122.514 446.899 122.538 446.675 122.515 446.453C122.493 446.231 122.423 446.017 122.312 445.823C122.201 445.63 122.05 445.462 121.87 445.331C120.763 444.571 118.499 445.431 117.551 446.162C117.515 446.189 117.276 446.419 117.018 446.67C117.018 446.614 117.024 446.549 117.026 446.475C117.064 446.417 117.103 446.358 117.141 446.302C117.715 445.466 118.293 444.735 118.809 444.091C119.109 443.728 119.381 443.405 119.642 443.106C120.726 443.135 121.808 442.998 122.851 442.699C123.303 442.53 123.713 442.265 124.052 441.922C124.391 441.579 124.652 441.166 124.815 440.712C124.872 440.496 124.883 440.271 124.847 440.051C124.811 439.83 124.729 439.62 124.606 439.434C124.483 439.247 124.323 439.089 124.135 438.968C123.947 438.848 123.736 438.768 123.515 438.735C122.182 438.571 120.568 440.375 120.064 441.463C120.02 441.558 119.507 443.105 119.532 443.105H119.56C119.303 443.388 119.031 443.695 118.74 444.035C118.211 444.665 117.62 445.382 117.027 446.203C117.036 444.912 116.849 442.228 115.148 442.039C112.902 441.791 112.22 444.35 113.591 445.764C113.98 446.139 114.44 446.434 114.944 446.631C115.447 446.828 115.984 446.923 116.525 446.912C116.084 447.55 115.64 448.234 115.225 448.978C114.612 450.044 114.094 451.163 113.679 452.321C113.674 452.335 113.671 452.349 113.666 452.363C113.679 451.97 113.679 450.869 113.666 450.785C113.53 449.594 112.566 447.372 111.252 447.108C111.032 447.07 110.807 447.079 110.591 447.134C110.375 447.189 110.173 447.289 109.998 447.427C109.823 447.565 109.679 447.738 109.575 447.936C109.472 448.133 109.411 448.351 109.397 448.573C109.409 449.056 109.526 449.53 109.739 449.962C109.953 450.395 110.258 450.776 110.634 451.079C111.553 451.7 112.56 452.179 113.622 452.5C113.229 453.689 112.915 454.903 112.684 456.134C112.544 456.849 112.426 457.575 112.318 458.304C112.318 457.964 112.318 457.66 112.311 457.617C112.175 456.426 111.211 454.204 109.897 453.94C109.677 453.902 109.452 453.911 109.236 453.966C109.02 454.021 108.818 454.121 108.643 454.259C108.468 454.397 108.324 454.57 108.22 454.768C108.117 454.965 108.056 455.183 108.042 455.405C108.053 455.888 108.17 456.362 108.383 456.795C108.597 457.227 108.902 457.608 109.278 457.911C110.168 458.52 111.146 458.99 112.178 459.303C112.14 459.583 112.098 459.862 112.06 460.143C111.878 461.487 111.702 462.83 111.49 464.143C111.415 464.605 111.325 465.058 111.236 465.511C111.236 465.211 111.236 464.955 111.229 464.911C111.093 463.72 110.129 461.498 108.815 461.234C108.595 461.196 108.37 461.205 108.153 461.26C107.937 461.315 107.735 461.415 107.56 461.553C107.385 461.691 107.241 461.865 107.137 462.063C107.034 462.26 106.973 462.477 106.959 462.7C106.971 463.182 107.089 463.655 107.302 464.086C107.516 464.518 107.821 464.898 108.196 465.2C109.058 465.797 110.008 466.257 111.011 466.562C110.906 467.024 110.802 467.486 110.679 467.927C110.589 468.227 110.522 468.527 110.414 468.819C110.306 469.111 110.214 469.407 110.114 469.697C109.904 470.247 109.69 470.817 109.471 471.35C109.323 471.722 109.171 472.073 109.024 472.427C109.104 471.968 109.241 471.066 109.244 470.989C109.245 469.935 108.976 468.897 108.463 467.976C108.468 467.858 108.463 467.741 108.446 467.624C108.421 467.402 108.35 467.189 108.238 466.996C108.125 466.804 107.973 466.637 107.792 466.507C107.611 466.378 107.404 466.287 107.186 466.242C106.967 466.198 106.742 466.199 106.524 466.247C105.224 466.573 104.364 468.837 104.284 470.033C104.284 470.103 104.313 470.875 104.343 471.361C104.283 471.078 104.226 470.802 104.16 470.512C104.033 469.935 103.89 469.365 103.737 468.75L103.481 467.859C103.403 467.559 103.281 467.253 103.181 466.947C102.935 466.241 102.652 465.538 102.351 464.837C103.403 464.635 104.418 464.273 105.36 463.762C105.766 463.501 106.11 463.154 106.368 462.746C106.626 462.338 106.792 461.879 106.854 461.4C106.863 461.177 106.826 460.955 106.744 460.747C106.662 460.54 106.537 460.352 106.377 460.196C106.218 460.041 106.027 459.92 105.818 459.842C105.609 459.765 105.386 459.733 105.163 459.747C103.826 459.872 102.635 461.979 102.375 463.147C102.359 463.22 102.267 464.08 102.225 464.555C102.041 464.134 101.859 463.713 101.659 463.295C101.08 462.084 100.459 460.878 99.842 459.67C99.654 459.301 99.47 458.93 99.284 458.56C100.373 458.352 101.424 457.981 102.403 457.46C102.809 457.198 103.152 456.852 103.41 456.444C103.668 456.036 103.834 455.577 103.897 455.098C103.906 454.875 103.869 454.653 103.787 454.445C103.705 454.238 103.58 454.05 103.42 453.894C103.261 453.739 103.07 453.618 102.861 453.54C102.652 453.463 102.429 453.431 102.206 453.445C100.869 453.569 99.678 455.677 99.418 456.845C99.398 456.933 99.267 458.173 99.249 458.489C98.842 457.673 98.443 456.856 98.082 456.036C97.5893 454.931 97.1691 453.796 96.824 452.636C97.9189 452.428 98.9766 452.057 99.962 451.536C100.368 451.274 100.711 450.928 100.969 450.52C101.227 450.112 101.393 449.653 101.456 449.174C101.465 448.951 101.428 448.729 101.346 448.522C101.264 448.314 101.139 448.126 100.979 447.97C100.82 447.814 100.629 447.694 100.42 447.617C100.211 447.539 99.9876 447.507 99.765 447.521C98.428 447.645 97.237 449.753 96.977 450.921C96.959 450.998 96.859 451.942 96.821 452.392L96.745 452.399C96.4285 451.22 96.2183 450.015 96.117 448.799C96.053 448.132 96.028 447.489 96.017 446.864C97.1034 446.779 98.1704 446.528 99.181 446.12C99.6127 445.905 99.9922 445.598 100.293 445.221C100.594 444.844 100.81 444.406 100.924 443.937C100.958 443.717 100.945 443.491 100.886 443.276C100.827 443.061 100.724 442.861 100.582 442.688C100.441 442.516 100.264 442.375 100.065 442.275C99.8652 442.175 99.6469 442.119 99.424 442.109C98.083 442.086 96.668 444.05 96.28 445.184C96.259 445.246 96.115 445.897 96.016 446.373C96.016 446.091 96.011 445.8 96.016 445.529C96.034 444.514 96.116 443.586 96.189 442.763C96.235 442.297 96.289 441.875 96.34 441.482C97.26 440.908 98.0866 440.197 98.791 439.373C99.075 438.983 99.2707 438.536 99.3643 438.062C99.4579 437.589 99.4472 437.101 99.333 436.632C99.2613 436.421 99.146 436.227 98.9946 436.064C98.8432 435.9 98.659 435.77 98.454 435.682C98.2491 435.594 98.0279 435.551 97.805 435.554C97.582 435.557 97.3623 435.607 97.16 435.701C95.96 436.301 95.608 438.694 95.787 439.88C95.803 439.98 96.229 441.557 96.249 441.543L96.273 441.527C96.215 441.905 96.156 442.311 96.103 442.755C96.008 443.577 95.909 444.507 95.869 445.525C95.862 445.712 95.856 445.905 95.85 446.097C95.35 445.297 93.771 443.064 92.02 443.507C89.899 444.044 90.358 445.92 92.058 446.353",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.799 446.372C691.048 446.612 692.329 446.629 693.584 446.421C693.568 447.188 693.576 447.996 693.639 448.835C693.715 450.063 693.9 451.282 694.192 452.477C694.192 452.491 694.201 452.505 694.205 452.519C693.999 452.184 693.392 451.267 693.337 451.202C692.567 450.284 690.537 448.961 689.295 449.467C689.091 449.557 688.908 449.688 688.758 449.853C688.608 450.018 688.494 450.213 688.424 450.425C688.355 450.637 688.33 450.861 688.353 451.083C688.376 451.305 688.445 451.52 688.556 451.713C688.832 452.109 689.191 452.44 689.607 452.683C690.024 452.926 690.489 453.076 690.969 453.121C692.078 453.132 693.183 452.976 694.246 452.658C694.574 453.866 694.982 455.051 695.467 456.205C695.746 456.879 696.048 457.549 696.359 458.217C696.171 457.934 696.001 457.682 695.974 457.649C695.204 456.73 693.174 455.408 691.932 455.913C691.728 456.003 691.545 456.134 691.395 456.3C691.245 456.465 691.131 456.659 691.062 456.871C690.992 457.083 690.967 457.307 690.99 457.529C691.012 457.751 691.081 457.966 691.192 458.159C691.468 458.555 691.827 458.886 692.244 459.129C692.661 459.373 693.126 459.522 693.606 459.567C694.684 459.585 695.758 459.437 696.791 459.129C696.913 459.384 697.032 459.64 697.155 459.895C697.745 461.116 698.34 462.332 698.885 463.544C699.078 463.97 699.252 464.397 699.428 464.824C699.261 464.573 699.119 464.361 699.093 464.332C698.323 463.414 696.293 462.091 695.051 462.597C694.847 462.687 694.664 462.818 694.514 462.983C694.364 463.148 694.25 463.343 694.18 463.555C694.111 463.767 694.086 463.991 694.109 464.213C694.132 464.435 694.201 464.65 694.312 464.843C694.588 465.239 694.947 465.57 695.363 465.813C695.78 466.056 696.245 466.206 696.725 466.251C697.774 466.273 698.82 466.132 699.825 465.834C699.992 466.277 700.16 466.72 700.302 467.156C700.391 467.456 700.502 467.739 700.573 468.045C700.644 468.351 700.73 468.645 700.809 468.945C700.937 469.52 701.074 470.114 701.185 470.679C701.266 471.071 701.335 471.446 701.407 471.824C701.22 471.398 700.837 470.569 700.797 470.504C700.174 469.479 698.37 467.866 697.063 468.177C696.848 468.235 696.647 468.337 696.474 468.478C696.301 468.618 696.159 468.794 696.058 468.993C695.957 469.191 695.899 469.409 695.888 469.632C695.877 469.855 695.913 470.077 695.993 470.285C696.206 470.718 696.51 471.099 696.886 471.403C697.261 471.706 697.697 471.924 698.165 472.042C699.254 472.222 700.363 472.236 701.456 472.083C701.572 472.708 701.678 473.318 701.768 473.895C701.838 474.333 701.902 474.753 701.961 475.158L702.798 475.171C702.723 474.722 702.642 474.251 702.553 473.76C702.438 473.125 702.303 472.448 702.153 471.754C702.785 471.512 703.402 471.233 704.001 470.919C704.799 471.627 705.69 472.221 706.65 472.686C706.402 473.271 706.15 473.838 705.912 474.369C705.781 474.66 705.651 474.939 705.524 475.213L706.409 475.227C706.486 475.05 706.563 474.874 706.641 474.69C706.897 474.097 707.157 473.457 707.418 472.798C708.489 473.065 709.594 473.168 710.695 473.104C711.173 473.037 711.63 472.866 712.036 472.603C712.441 472.341 712.784 471.994 713.041 471.585C713.143 471.387 713.202 471.169 713.214 470.946C713.226 470.724 713.192 470.501 713.112 470.293C713.033 470.084 712.91 469.895 712.753 469.737C712.595 469.579 712.406 469.456 712.198 469.376C710.932 468.929 708.967 470.344 708.241 471.298C708.198 471.354 707.801 472.017 707.557 472.438C707.663 472.168 707.769 471.908 707.874 471.628C708.085 471.078 708.28 470.522 708.491 469.928C708.584 469.635 708.677 469.34 708.771 469.043C708.871 468.751 708.938 468.428 709.025 468.117C709.209 467.393 709.361 466.651 709.496 465.899C710.484 466.311 711.53 466.568 712.596 466.663C713.079 466.669 713.557 466.569 713.997 466.371C714.437 466.173 714.828 465.881 715.144 465.516C715.275 465.335 715.366 465.129 715.412 464.911C715.457 464.693 715.457 464.467 715.409 464.249C715.362 464.031 715.27 463.825 715.138 463.646C715.006 463.466 714.838 463.316 714.644 463.205C713.46 462.572 711.304 463.673 710.444 464.505C710.39 464.558 709.844 465.225 709.544 465.596C709.622 465.144 709.703 464.696 709.767 464.233C709.952 462.905 710.099 461.555 710.251 460.208C710.297 459.796 710.351 459.385 710.398 458.974C711.422 459.4 712.503 459.67 713.607 459.774C714.09 459.779 714.568 459.68 715.008 459.482C715.448 459.283 715.839 458.992 716.155 458.627C716.286 458.446 716.377 458.24 716.423 458.022C716.468 457.804 716.468 457.578 716.42 457.36C716.373 457.142 716.281 456.936 716.149 456.757C716.017 456.577 715.849 456.427 715.655 456.316C714.471 455.683 712.315 456.784 711.455 457.616C711.39 457.679 710.598 458.64 710.408 458.894C710.517 457.988 710.635 457.088 710.788 456.204C710.987 455.009 711.264 453.829 711.616 452.67C712.645 453.099 713.732 453.373 714.841 453.482C715.324 453.488 715.802 453.388 716.242 453.19C716.682 452.992 717.074 452.7 717.39 452.335C717.521 452.154 717.612 451.948 717.658 451.73C717.704 451.512 717.703 451.286 717.656 451.068C717.609 450.85 717.516 450.644 717.384 450.464C717.252 450.285 717.084 450.135 716.89 450.024C715.706 449.391 713.551 450.492 712.69 451.324C712.633 451.379 712.029 452.11 711.75 452.464L711.683 452.428C712.069 451.272 712.557 450.153 713.142 449.084C713.457 448.491 713.79 447.943 714.127 447.416C715.081 447.944 716.109 448.324 717.177 448.541C717.656 448.6 718.142 448.553 718.601 448.405C719.06 448.257 719.482 448.011 719.836 447.683C719.986 447.518 720.099 447.323 720.169 447.111C720.238 446.899 720.262 446.675 720.24 446.453C720.217 446.231 720.147 446.017 720.036 445.823C719.925 445.63 719.774 445.462 719.594 445.331C718.487 444.571 716.223 445.431 715.275 446.162C715.239 446.189 715 446.419 714.742 446.67C714.742 446.614 714.747 446.549 714.75 446.475C714.788 446.417 714.827 446.358 714.865 446.302C715.439 445.466 716.017 444.735 716.533 444.091C716.833 443.728 717.105 443.405 717.366 443.106C718.45 443.135 719.532 442.998 720.575 442.699C721.027 442.53 721.437 442.265 721.776 441.922C722.115 441.579 722.376 441.166 722.539 440.712C722.596 440.496 722.607 440.271 722.571 440.051C722.535 439.83 722.453 439.62 722.33 439.434C722.207 439.247 722.047 439.089 721.859 438.968C721.671 438.848 721.46 438.768 721.239 438.735C719.906 438.571 718.292 440.375 717.788 441.463C717.744 441.558 717.232 443.105 717.256 443.105H717.284C717.027 443.388 716.755 443.695 716.465 444.035C715.936 444.665 715.345 445.382 714.752 446.203C714.762 444.912 714.574 442.228 712.873 442.039C710.627 441.791 709.944 444.35 711.316 445.764C711.706 446.139 712.165 446.434 712.669 446.631C713.172 446.828 713.71 446.923 714.25 446.912C713.809 447.55 713.365 448.234 712.95 448.978C712.336 450.044 711.819 451.163 711.404 452.321C711.399 452.335 711.396 452.349 711.391 452.363C711.404 451.97 711.404 450.869 711.391 450.785C711.255 449.594 710.291 447.372 708.977 447.108C708.757 447.07 708.532 447.079 708.316 447.134C708.1 447.189 707.898 447.289 707.723 447.427C707.548 447.565 707.404 447.738 707.3 447.936C707.197 448.133 707.136 448.351 707.122 448.573C707.134 449.056 707.251 449.53 707.464 449.962C707.678 450.395 707.983 450.776 708.359 451.079C709.278 451.7 710.285 452.179 711.347 452.5C710.954 453.689 710.641 454.903 710.409 456.134C710.269 456.849 710.151 457.575 710.043 458.304C710.043 457.964 710.043 457.66 710.036 457.617C709.9 456.426 708.936 454.204 707.622 453.94C707.402 453.902 707.177 453.911 706.961 453.965C706.745 454.02 706.542 454.12 706.367 454.258C706.192 454.397 706.048 454.57 705.945 454.768C705.842 454.965 705.781 455.182 705.767 455.405C705.778 455.888 705.895 456.362 706.108 456.795C706.322 457.227 706.627 457.608 707.003 457.911C707.893 458.52 708.871 458.99 709.903 459.303C709.865 459.583 709.823 459.862 709.785 460.143C709.603 461.487 709.427 462.83 709.215 464.143C709.14 464.605 709.05 465.058 708.961 465.511C708.961 465.211 708.961 464.955 708.954 464.911C708.818 463.72 707.854 461.498 706.54 461.234C706.32 461.196 706.095 461.205 705.879 461.26C705.662 461.315 705.46 461.415 705.285 461.553C705.11 461.691 704.966 461.865 704.862 462.063C704.759 462.26 704.698 462.477 704.684 462.7C704.697 463.182 704.814 463.655 705.027 464.086C705.241 464.518 705.546 464.898 705.921 465.2C706.783 465.797 707.732 466.257 708.735 466.562C708.635 467.024 708.527 467.486 708.404 467.927C708.314 468.227 708.247 468.527 708.139 468.819C708.031 469.111 707.939 469.407 707.839 469.697C707.629 470.247 707.415 470.817 707.196 471.35C707.048 471.722 706.896 472.073 706.749 472.427C706.829 471.968 706.966 471.066 706.969 470.989C706.97 469.935 706.701 468.897 706.188 467.976C706.193 467.858 706.188 467.741 706.171 467.624C706.146 467.402 706.075 467.189 705.963 466.996C705.85 466.804 705.698 466.637 705.517 466.507C705.336 466.378 705.129 466.287 704.911 466.242C704.692 466.198 704.467 466.199 704.249 466.247C702.949 466.573 702.089 468.837 702.009 470.033C702.004 470.103 702.038 470.875 702.068 471.361C702.007 471.078 701.951 470.802 701.885 470.512C701.758 469.935 701.615 469.365 701.462 468.75L701.206 467.859C701.128 467.559 701.006 467.253 700.906 466.947C700.66 466.241 700.377 465.538 700.076 464.837C701.128 464.635 702.143 464.273 703.085 463.762C703.491 463.501 703.835 463.154 704.093 462.746C704.351 462.338 704.517 461.879 704.579 461.4C704.589 461.177 704.551 460.955 704.469 460.747C704.387 460.54 704.262 460.352 704.102 460.196C703.943 460.041 703.752 459.92 703.543 459.842C703.334 459.765 703.111 459.733 702.888 459.747C701.551 459.872 700.36 461.979 700.1 463.147C700.084 463.22 699.992 464.08 699.95 464.555C699.766 464.134 699.584 463.713 699.384 463.295C698.805 462.084 698.184 460.878 697.567 459.67C697.378 459.301 697.195 458.93 697.009 458.56C698.098 458.352 699.149 457.981 700.128 457.46C700.534 457.198 700.877 456.852 701.135 456.444C701.393 456.036 701.559 455.577 701.622 455.098C701.632 454.875 701.594 454.653 701.512 454.445C701.43 454.238 701.305 454.05 701.145 453.894C700.985 453.738 700.795 453.618 700.585 453.54C700.376 453.463 700.153 453.43 699.93 453.445C698.594 453.569 697.403 455.677 697.143 456.845C697.123 456.933 696.992 458.173 696.974 458.489C696.567 457.673 696.167 456.856 695.807 456.036C695.315 454.931 694.895 453.795 694.549 452.636C695.644 452.428 696.702 452.057 697.687 451.536C698.093 451.274 698.436 450.928 698.694 450.52C698.952 450.112 699.118 449.653 699.181 449.174C699.191 448.951 699.153 448.729 699.071 448.522C698.989 448.314 698.864 448.126 698.704 447.97C698.545 447.814 698.354 447.694 698.145 447.617C697.936 447.539 697.713 447.507 697.49 447.521C696.153 447.645 694.962 449.753 694.702 450.921C694.684 450.998 694.584 451.942 694.546 452.392L694.47 452.399C694.154 451.22 693.943 450.015 693.842 448.799C693.777 448.132 693.753 447.489 693.742 446.864C694.828 446.779 695.895 446.528 696.906 446.12C697.338 445.905 697.717 445.598 698.018 445.221C698.319 444.844 698.535 444.406 698.649 443.937C698.683 443.717 698.67 443.491 698.611 443.276C698.552 443.061 698.449 442.861 698.307 442.688C698.166 442.516 697.989 442.375 697.79 442.275C697.59 442.175 697.372 442.119 697.149 442.109C695.808 442.086 694.393 444.05 694.005 445.184C693.984 445.246 693.84 445.897 693.741 446.373C693.741 446.091 693.736 445.8 693.741 445.529C693.759 444.514 693.841 443.586 693.913 442.763C693.959 442.297 694.013 441.875 694.065 441.482C694.985 440.908 695.812 440.197 696.516 439.373C696.8 438.983 696.996 438.536 697.089 438.062C697.183 437.589 697.172 437.101 697.058 436.632C696.986 436.421 696.871 436.227 696.72 436.064C696.568 435.9 696.384 435.77 696.179 435.682C695.974 435.594 695.753 435.551 695.53 435.554C695.307 435.557 695.087 435.607 694.885 435.701C693.685 436.301 693.333 438.694 693.512 439.88C693.528 439.98 693.954 441.557 693.974 441.543L693.998 441.527C693.94 441.905 693.881 442.311 693.827 442.755C693.733 443.577 693.634 444.507 693.594 445.525C693.587 445.712 693.581 445.905 693.575 446.097C693.075 445.297 691.496 443.064 689.745 443.507C687.624 444.044 688.083 445.92 689.783 446.353",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_644_4520",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 747,
    height: 476
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M746.522 0H0V475.626H746.522V0Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_644_4520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M719.692 56.841V269.233C719.692 274.198 717.72 278.96 714.209 282.47C710.698 285.981 705.937 287.954 700.972 287.954H612.19C607.225 287.954 602.463 285.981 598.953 282.47C595.442 278.96 593.47 274.198 593.47 269.233V56.841C593.471 51.877 595.444 47.1168 598.954 43.6072C602.465 40.0976 607.226 38.126 612.19 38.126H649.313L649.349 38.262C650.449 42.212 652.975 44.782 655.778 44.782H657.385C660.185 44.782 662.715 42.212 663.813 38.262L663.856 38.126H700.972C705.936 38.126 710.696 40.0976 714.207 43.6072C717.718 47.1168 719.69 51.877 719.692 56.841Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.692 56.841V269.233C719.692 274.198 717.72 278.96 714.209 282.47C710.698 285.981 705.937 287.954 700.972 287.954H612.19C607.225 287.954 602.463 285.981 598.953 282.47C595.442 278.96 593.47 274.198 593.47 269.233V56.841C593.471 51.877 595.444 47.1168 598.954 43.6072C602.465 40.0976 607.226 38.126 612.19 38.126H649.313L649.349 38.262C650.449 42.212 652.975 44.782 655.778 44.782H657.385C660.185 44.782 662.715 42.212 663.813 38.262L663.856 38.126H700.972C705.936 38.126 710.696 40.0976 714.207 43.6072C717.718 47.1168 719.69 51.877 719.692 56.841Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.85 273.022C594.723 277.24 597.023 281.029 600.363 283.749C603.703 286.469 607.879 287.955 612.186 287.955H700.968C705.276 287.954 709.451 286.469 712.791 283.749C716.131 281.029 718.431 277.24 719.304 273.022H593.85Z",
    fill: "#3561E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.85 273.022C594.723 277.24 597.023 281.029 600.363 283.749C603.703 286.469 607.879 287.955 612.186 287.955H700.968C705.276 287.954 709.451 286.469 712.791 283.749C716.131 281.029 718.431 277.24 719.304 273.022H593.85Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.692 61.072V56.841C719.69 51.877 717.718 47.1168 714.207 43.6072C710.696 40.0976 705.936 38.126 700.972 38.126H663.856L663.813 38.262C662.713 42.212 660.188 44.782 657.385 44.782H655.778C652.978 44.782 650.448 42.212 649.349 38.262L649.313 38.126H612.19C607.226 38.126 602.465 40.0976 598.954 43.6072C595.444 47.1168 593.471 51.877 593.47 56.841V61.072H719.692Z",
    fill: "#3561E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.692 61.072V56.841C719.69 51.877 717.718 47.1168 714.207 43.6072C710.696 40.0976 705.936 38.126 700.972 38.126H663.856L663.813 38.262C662.713 42.212 660.188 44.782 657.385 44.782H655.778C652.978 44.782 650.448 42.212 649.349 38.262L649.313 38.126H612.19C607.226 38.126 602.465 40.0976 598.954 43.6072C595.444 47.1168 593.471 51.877 593.47 56.841V61.072H719.692Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.871 200.576V141.515H697.984C698.219 141.515 698.449 141.448 698.647 141.321C698.844 141.194 699.002 141.013 699.099 140.799L719.692 95.7759V89.8759L697.197 139.061H670.871V61.7229H668.418V94.1009C643.932 91.6849 629.589 103.229 621.841 113.461C616.97 119.984 613.349 127.353 611.163 135.196L593.474 123.965V126.872L625.155 146.986H625.135V182.872L593.474 177.098V179.592L668.418 193.261V199.986L593.474 259.851V262.991L627.367 235.916L653.2 270.866C653.314 271.021 653.463 271.147 653.634 271.234C653.805 271.32 653.995 271.366 654.187 271.366C654.288 271.366 654.389 271.353 654.487 271.327L695.209 260.899V272.484H697.662V237.16C697.662 236.933 697.599 236.711 697.48 236.518C697.362 236.324 697.192 236.168 696.989 236.066L687.843 231.439L703.475 214.387L719.689 220.623V217.995L703.575 211.795C703.345 211.707 703.094 211.69 702.854 211.746C702.615 211.802 702.398 211.93 702.231 212.111L685.572 230.288L654.25 214.443L670.411 201.534C670.555 201.419 670.671 201.273 670.751 201.108C670.831 200.942 670.871 200.76 670.871 200.576ZM695.213 237.914V258.365L654.683 268.745L629.283 234.386L652.14 216.127L695.213 237.914ZM668.419 190.766L627.589 183.32V148.531L668.419 174.455V190.766ZM668.419 171.549L613.342 136.58C615.429 128.772 618.976 121.43 623.797 114.943C634.508 100.797 649.52 94.6209 668.418 96.5639L668.419 171.549Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.693 175.325H716.018L706.744 198.517H688.196L697.986 175.84H683.558V153.684H705.199L719.693 125.548V175.325Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.619 85.5339H598.218V100.869H616.619V85.5339Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.936 85.5349H619.687V96.5759H632.936V85.5349Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.88 134.374L664.419 163.785V102.117C664.419 102.117 631.846 98.955 618.88 134.374Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.449 85.5339H636.862V92.6909H645.449V85.5339Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.397 229.681L644.835 241.335L654.035 258.51L687.158 256.67L688.998 240.722L676.117 235.202L670.596 243.789L665.075 240.721L669.983 231.521L661.397 229.681Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.332 195.082V228.217L593.476 235.775V194.382L608.332 195.082Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.059 215.651V196.251L612.448 195.285V226.133L633.059 215.651Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.151 196.388V214.076L648.517 207.789V196.968L636.151 196.388Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.72 132.392V108.673H725.574V52.5649C725.574 47.6006 723.602 42.8396 720.092 39.3293C716.581 35.819 711.82 33.8469 706.856 33.8469H606.309C601.345 33.8469 596.584 35.819 593.073 39.3292C589.563 42.8395 587.59 47.6005 587.59 52.5649V282.607C587.59 287.571 589.563 292.332 593.073 295.843C596.584 299.353 601.345 301.325 606.309 301.325H706.856C711.82 301.325 716.581 299.353 720.092 295.843C723.602 292.332 725.574 287.571 725.574 282.607V152.607H727.72V138.592H725.574V132.392H727.72ZM719.693 269.234C719.693 274.199 717.721 278.96 714.21 282.471C710.699 285.982 705.938 287.954 700.973 287.954H612.191C607.226 287.954 602.465 285.982 598.954 282.471C595.443 278.96 593.471 274.199 593.471 269.234V56.8429C593.472 51.8789 595.445 47.1187 598.956 43.6091C602.466 40.0995 607.227 38.1279 612.191 38.1279H649.314L649.35 38.2629C650.45 42.2129 652.976 44.7829 655.779 44.7829H657.386C660.186 44.7829 662.716 42.2129 663.814 38.2629L663.857 38.1279H700.973C705.937 38.1279 710.698 40.0995 714.208 43.6091C717.719 47.1187 719.692 51.8789 719.693 56.8429V269.234Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.72 132.392V108.673H725.574V52.5649C725.574 47.6006 723.602 42.8396 720.092 39.3293C716.581 35.819 711.82 33.8469 706.856 33.8469H606.309C601.345 33.8469 596.584 35.819 593.073 39.3292C589.563 42.8395 587.59 47.6005 587.59 52.5649V282.607C587.59 287.571 589.563 292.332 593.073 295.843C596.584 299.353 601.345 301.325 606.309 301.325H706.856C711.82 301.325 716.581 299.353 720.092 295.843C723.602 292.332 725.574 287.571 725.574 282.607V152.607H727.72V138.592H725.574V132.392H727.72ZM719.693 269.234C719.693 274.199 717.721 278.96 714.21 282.471C710.699 285.982 705.938 287.954 700.973 287.954H612.191C607.226 287.954 602.465 285.982 598.954 282.471C595.443 278.96 593.471 274.199 593.471 269.234V56.8429C593.472 51.8789 595.445 47.1187 598.956 43.6091C602.466 40.0995 607.227 38.1279 612.191 38.1279H649.314L649.35 38.2629C650.45 42.2129 652.976 44.7829 655.779 44.7829H657.386C660.186 44.7829 662.716 42.2129 663.814 38.2629L663.857 38.1279H700.973C705.937 38.1279 710.698 40.0995 714.208 43.6091C717.719 47.1187 719.692 51.8789 719.693 56.8429V269.234Z",
    stroke: "#263238",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.688 36.4248H608.476C603.512 36.4248 598.751 38.3968 595.24 41.9071C591.73 45.4174 589.757 50.1784 589.757 55.1428V280.028C589.757 284.992 591.73 289.753 595.24 293.263C598.751 296.774 603.512 298.746 608.476 298.746H704.688C709.652 298.746 714.413 296.774 717.924 293.263C721.434 289.753 723.406 284.992 723.406 280.028V55.1428C723.406 50.1785 721.434 45.4175 717.924 41.9072C714.413 38.3969 709.652 36.4248 704.688 36.4248ZM719.688 269.234C719.688 271.692 719.204 274.126 718.263 276.398C717.322 278.669 715.943 280.733 714.205 282.471C712.467 284.209 710.403 285.588 708.132 286.529C705.861 287.47 703.426 287.954 700.968 287.954H612.191C609.733 287.954 607.298 287.47 605.027 286.529C602.756 285.588 600.692 284.209 598.954 282.471C597.216 280.733 595.837 278.669 594.896 276.398C593.955 274.126 593.471 271.692 593.471 269.234V56.8418C593.472 51.8778 595.445 47.1176 598.956 43.608C602.466 40.0984 607.227 38.1268 612.191 38.1268H649.314L649.35 38.2618C650.45 42.2118 652.976 44.7818 655.779 44.7818H657.386C660.186 44.7818 662.716 42.2118 663.814 38.2618L663.857 38.1268H700.973C705.937 38.1268 710.698 40.0984 714.208 43.608C717.719 47.1176 719.692 51.8778 719.693 56.8418L719.688 269.234Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.688 36.4248H608.476C603.512 36.4248 598.751 38.3968 595.24 41.9071C591.73 45.4174 589.757 50.1784 589.757 55.1428V280.028C589.757 284.992 591.73 289.753 595.24 293.263C598.751 296.774 603.512 298.746 608.476 298.746H704.688C709.652 298.746 714.413 296.774 717.924 293.263C721.434 289.753 723.406 284.992 723.406 280.028V55.1428C723.406 50.1785 721.434 45.4175 717.924 41.9072C714.413 38.3969 709.652 36.4248 704.688 36.4248ZM719.688 269.234C719.688 271.692 719.204 274.126 718.263 276.398C717.322 278.669 715.943 280.733 714.205 282.471C712.467 284.209 710.403 285.588 708.132 286.529C705.861 287.47 703.426 287.954 700.968 287.954H612.191C609.733 287.954 607.298 287.47 605.027 286.529C602.756 285.588 600.692 284.209 598.954 282.471C597.216 280.733 595.837 278.669 594.896 276.398C593.955 274.126 593.471 271.692 593.471 269.234V56.8418C593.472 51.8778 595.445 47.1176 598.956 43.608C602.466 40.0984 607.227 38.1268 612.191 38.1268H649.314L649.35 38.2618C650.45 42.2118 652.976 44.7818 655.779 44.7818H657.386C660.186 44.7818 662.716 42.2118 663.814 38.2618L663.857 38.1268H700.973C705.937 38.1268 710.698 40.0984 714.208 43.608C717.719 47.1176 719.692 51.8778 719.693 56.8418L719.688 269.234Z",
    stroke: "#263238",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.955 39.0219C657.955 38.6744 657.852 38.3348 657.658 38.046C657.465 37.7572 657.191 37.5322 656.87 37.3993C656.549 37.2665 656.195 37.2318 655.855 37.2998C655.514 37.3677 655.201 37.5351 654.955 37.7808C654.71 38.0266 654.542 38.3397 654.475 38.6805C654.407 39.0213 654.442 39.3745 654.575 39.6955C654.708 40.0165 654.933 40.2908 655.222 40.4838C655.511 40.6768 655.851 40.7799 656.198 40.7799C656.429 40.7799 656.657 40.7344 656.871 40.646C657.084 40.5577 657.278 40.4282 657.441 40.2649C657.604 40.1016 657.733 39.9078 657.822 39.6946C657.91 39.4813 657.955 39.2527 657.955 39.0219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.69 45.7568C604.69 47.5348 602.69 48.1758 602.685 49.5318V49.6248H604.623V50.2248H602.037V49.7188C602.037 47.8188 604.037 47.4448 604.037 45.7848C604.037 45.1788 603.837 44.8578 603.346 44.8578C602.855 44.8578 602.655 45.2028 602.655 45.7258V46.2488H602.041V45.7678C602.041 44.8678 602.453 44.2678 603.362 44.2678C604.271 44.2678 604.694 44.8578 604.694 45.7598",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.914 45.7479V45.8989C607.942 46.1514 607.888 46.4062 607.759 46.6251C607.63 46.844 607.433 47.0151 607.199 47.1129C607.435 47.2106 607.633 47.383 607.762 47.6036C607.891 47.8242 607.944 48.0811 607.914 48.3349V48.7879C607.914 49.6879 607.493 50.2799 606.583 50.2799C605.673 50.2799 605.261 49.6899 605.261 48.7879V48.3879H605.875V48.8339C605.875 49.3649 606.094 49.6849 606.566 49.6849C607.038 49.6849 607.257 49.3739 607.257 48.7749V48.3179C607.257 47.7359 607.012 47.4589 606.515 47.4419H606.16V46.8519H606.548C606.65 46.8529 606.751 46.8319 606.844 46.7902C606.937 46.7484 607.021 46.6871 607.088 46.6102C607.155 46.5333 607.205 46.4429 607.234 46.3449C607.263 46.247 607.27 46.144 607.256 46.0429V45.7739C607.256 45.1669 607.045 44.8559 606.565 44.8559C606.085 44.8559 605.874 45.1839 605.874 45.7149V46.0149H605.26V45.7479C605.26 44.8479 605.681 44.2649 606.582 44.2649C607.483 44.2649 607.914 44.8469 607.914 45.7479Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.191 47.0108H608.559V46.1938H609.191V47.0108ZM609.191 50.2218H608.559V49.4049H609.191V50.2218Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.523 46.7259C610.609 46.5706 610.736 46.4424 610.891 46.356C611.046 46.2695 611.222 46.2283 611.399 46.2369C612.157 46.2369 612.499 46.7939 612.499 47.6369V48.7909C612.499 49.6909 612.07 50.2829 611.168 50.2829C610.266 50.2829 609.841 49.6909 609.841 48.7909V48.3909H610.455V48.8289C610.455 49.3599 610.674 49.6799 611.146 49.6799C611.618 49.6799 611.837 49.3599 611.837 48.8289V47.6909C611.837 47.1599 611.618 46.8399 611.146 46.8399C611.06 46.8358 610.975 46.8491 610.894 46.879C610.814 46.9089 610.74 46.9548 610.678 47.0138C610.616 47.0728 610.566 47.1439 610.532 47.2226C610.498 47.3013 610.48 47.3861 610.48 47.4719V47.6069H609.866L610.026 44.3289H612.351V44.9189H610.615L610.523 46.7259Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.773 45.7389V45.8479H615.159V45.6969C615.159 45.1669 614.939 44.8549 614.459 44.8549C613.959 44.8549 613.743 45.1749 613.743 45.8069V47.1289C613.812 46.9345 613.942 46.7678 614.113 46.6538C614.285 46.5398 614.489 46.4847 614.695 46.4969C615.453 46.4969 615.795 47.0449 615.795 47.8969V48.7879C615.795 49.6879 615.347 50.2789 614.446 50.2789C613.545 50.2789 613.089 49.6899 613.089 48.7879V45.7809C613.089 44.8459 613.511 44.2649 614.446 44.2649C615.356 44.2649 615.777 44.8379 615.777 45.7389M613.747 47.9469V48.8319C613.747 49.3619 613.966 49.6829 614.447 49.6829C614.928 49.6829 615.147 49.3619 615.147 48.8319V47.9469C615.147 47.4159 614.92 47.0959 614.447 47.0959C613.974 47.0959 613.747 47.4159 613.747 47.9469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.162 45.998H678.497V50.162H680.162V45.998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.381 45.165H680.716V50.162H682.381V45.165Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.602 44.573H682.937V50.162H684.602V44.573Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.823 43.543H685.158V50.162H686.823V43.543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.432 50.0479H697.44V43.9419H707.432V50.0479ZM697.995 49.4929H706.877V44.4929H697.995V49.4929Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.102 45.0999H698.828V48.8879H704.102V45.0999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.342 46.2759H707.085V47.7139H708.342V46.2759Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.779 48.7189C693.712 48.719 693.646 48.7006 693.589 48.6659C693.095 48.2963 692.496 48.0933 691.878 48.0863C691.261 48.0793 690.658 48.2686 690.155 48.6269C690.118 48.6591 690.075 48.6838 690.029 48.6995C689.982 48.7151 689.933 48.7215 689.884 48.7182C689.836 48.7149 689.788 48.702 689.744 48.6803C689.7 48.6585 689.661 48.6283 689.629 48.5914C689.596 48.5545 689.572 48.5116 689.556 48.4652C689.54 48.4188 689.534 48.3697 689.537 48.3208C689.541 48.2719 689.553 48.2242 689.575 48.1802C689.597 48.1363 689.627 48.0971 689.664 48.0649C690.283 47.5981 691.036 47.3423 691.811 47.3349C692.586 47.3275 693.343 47.569 693.971 48.0239C694.041 48.0661 694.095 48.1298 694.125 48.2055C694.155 48.2812 694.16 48.3646 694.138 48.4432C694.116 48.5217 694.07 48.591 694.005 48.6406C693.941 48.6902 693.861 48.7173 693.78 48.7179",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.528 47.4669C694.461 47.4668 694.395 47.4484 694.337 47.4139C691.398 45.6659 689.421 47.3569 689.401 47.3729C689.365 47.4075 689.322 47.4344 689.275 47.4519C689.227 47.4695 689.177 47.4774 689.127 47.4751C689.077 47.4729 689.028 47.4605 688.983 47.4388C688.937 47.4171 688.897 47.3864 688.864 47.3487C688.831 47.311 688.805 47.267 688.79 47.2193C688.774 47.1716 688.768 47.1212 688.772 47.0712C688.777 47.0211 688.791 46.9725 688.814 46.9281C688.838 46.8837 688.87 46.8445 688.909 46.8129C688.933 46.7909 691.316 44.7499 694.72 46.7719C694.79 46.8136 694.845 46.8773 694.876 46.9532C694.906 47.0291 694.911 47.1129 694.89 47.1919C694.868 47.2708 694.821 47.3404 694.756 47.3899C694.69 47.4394 694.611 47.4661 694.529 47.4659",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.208 46.0119C695.141 46.0119 695.075 45.9936 695.018 45.9589C691.294 43.7449 688.818 45.8299 688.718 45.9199C688.644 45.9852 688.546 46.0181 688.447 46.0116C688.349 46.005 688.256 45.9595 688.191 45.8849C688.126 45.8104 688.093 45.713 688.099 45.6142C688.106 45.5154 688.152 45.4232 688.226 45.3579C688.255 45.3319 691.197 42.8159 695.404 45.3169C695.474 45.3591 695.528 45.4229 695.558 45.4985C695.588 45.5742 695.593 45.6576 695.571 45.7362C695.55 45.8147 695.503 45.8841 695.438 45.9336C695.374 45.9832 695.295 46.0104 695.213 46.0109",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.653 49.3449C692.653 49.5301 692.598 49.711 692.495 49.865C692.392 50.0189 692.246 50.1388 692.075 50.2097C691.904 50.2805 691.716 50.2991 691.534 50.263C691.353 50.2268 691.186 50.1377 691.055 50.0068C690.924 49.8759 690.835 49.7091 690.799 49.5275C690.763 49.346 690.781 49.1578 690.852 48.9867C690.923 48.8157 691.043 48.6695 691.197 48.5667C691.351 48.4638 691.532 48.4089 691.717 48.4089C691.965 48.4089 692.203 48.5076 692.379 48.6831C692.554 48.8586 692.653 49.0967 692.653 49.3449Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.316 131.05C698.688 130.765 694.416 132.381 692.785 134.658C691.154 136.935 694.143 142.433 694.143 142.433C694.143 142.433 704.288 137.967 705.924 135.69C707.56 133.413 705.944 131.335 702.316 131.05ZM698.17 136.824C696.718 136.71 696.07 135.879 696.727 134.968C697.212 134.455 697.807 134.059 698.467 133.809C699.128 133.558 699.836 133.461 700.539 133.524C701.99 133.639 702.639 134.47 701.982 135.381C701.497 135.893 700.902 136.29 700.242 136.539C699.581 136.789 698.873 136.887 698.17 136.824Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.147 118.454C691.881 118.454 689.708 119.354 688.106 120.956C686.504 122.558 685.604 124.731 685.604 126.997C685.604 131.715 694.147 142.032 694.147 142.032C694.147 142.032 702.69 131.715 702.69 126.997C702.69 124.731 701.79 122.558 700.188 120.956C698.586 119.354 696.413 118.454 694.147 118.454ZM694.147 130.414C693.471 130.414 692.811 130.213 692.249 129.838C691.687 129.463 691.249 128.929 690.99 128.304C690.731 127.68 690.664 126.993 690.796 126.33C690.927 125.667 691.253 125.059 691.731 124.581C692.209 124.103 692.818 123.777 693.48 123.646C694.143 123.514 694.83 123.581 695.455 123.84C696.079 124.099 696.613 124.537 696.988 125.098C697.364 125.66 697.564 126.321 697.564 126.997C697.564 127.903 697.204 128.772 696.563 129.413C695.922 130.054 695.053 130.414 694.147 130.414Z",
    fill: "#3561E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.147 118.454C691.881 118.454 689.708 119.354 688.106 120.956C686.504 122.558 685.604 124.731 685.604 126.997C685.604 131.715 694.147 142.032 694.147 142.032C694.147 142.032 702.69 131.715 702.69 126.997C702.69 124.731 701.79 122.558 700.188 120.956C698.586 119.354 696.413 118.454 694.147 118.454ZM694.147 130.414C693.471 130.414 692.811 130.213 692.249 129.838C691.687 129.463 691.249 128.929 690.99 128.304C690.731 127.68 690.664 126.993 690.796 126.33C690.927 125.667 691.253 125.059 691.731 124.581C692.209 124.103 692.818 123.777 693.48 123.646C694.143 123.514 694.83 123.581 695.455 123.84C696.079 124.099 696.613 124.537 696.988 125.098C697.364 125.66 697.564 126.321 697.564 126.997C697.563 127.902 697.202 128.77 696.561 129.41C695.921 130.05 695.052 130.409 694.147 130.409V130.414Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.951 214.081L652.733 215.084",
    stroke: "#263238",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.264 217.117L631.739 232.366",
    stroke: "#263238",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeDasharray: "3.04 3.04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.503 233.382L629.285 234.385",
    stroke: "#263238",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.9 142.028H670.871V200.154L653.952 214.081",
    stroke: "#263238",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.105 214.443C659.105 213.483 658.82 212.544 658.286 211.746C657.753 210.948 656.995 210.326 656.107 209.958C655.22 209.591 654.244 209.495 653.303 209.682C652.361 209.87 651.496 210.332 650.817 211.011C650.138 211.69 649.676 212.555 649.488 213.496C649.301 214.438 649.397 215.414 649.764 216.301C650.132 217.188 650.754 217.947 651.552 218.48C652.35 219.014 653.289 219.299 654.249 219.299C655.537 219.299 656.772 218.787 657.683 217.877C658.593 216.966 659.105 215.731 659.105 214.443Z",
    fill: "#3561E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.105 214.443C659.105 213.483 658.82 212.544 658.286 211.746C657.753 210.948 656.995 210.326 656.107 209.958C655.22 209.591 654.244 209.495 653.303 209.682C652.361 209.87 651.496 210.332 650.817 211.011C650.138 211.69 649.676 212.555 649.488 213.496C649.301 214.438 649.397 215.414 649.764 216.301C650.132 217.188 650.754 217.947 651.552 218.48C652.35 219.014 653.289 219.299 654.249 219.299C655.537 219.299 656.772 218.787 657.683 217.877C658.593 216.966 659.105 215.731 659.105 214.443Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_644_4520",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 747,
    height: 476
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M746.522 0H0V475.626H746.522V0Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_644_4520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.032 207.125H27.874C27.2365 207.125 26.6052 206.999 26.0162 206.755C25.4273 206.511 24.8921 206.154 24.4414 205.703C23.9906 205.252 23.6331 204.717 23.3892 204.128C23.1453 203.539 23.0199 202.907 23.02 202.27V42.4129C23.02 40.141 23.9225 37.9621 25.5289 36.3555C27.1353 34.7489 29.3141 33.8462 31.586 33.8459H260.675C262.946 33.847 265.124 34.7501 266.73 36.3566C268.336 37.9631 269.238 40.1415 269.238 42.4129V197.913C269.238 200.355 268.268 202.698 266.541 204.425C264.814 206.152 262.471 207.122 260.029 207.122",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.238 94.4999V89.8689H264.349L256.578 76.6389H269.238V73.3319H254.638L251.53 68.0389H269.238V64.7319H249.589L243.372 54.1479H239.404L245.345 64.7319H213.893L208.974 54.1479H205.006L209.648 64.7319H180.591L178.545 54.1479H174.576L176.347 64.7319H148.273L148.115 54.1479H144.146L144.028 64.7319H115.876L117.686 54.1479H113.718L111.633 64.7319H83.598L87.258 54.1479H83.289L79.354 64.7319H50.887L56.828 54.1479H52.859L46.638 64.7319H23.02V68.0389H44.699L41.591 73.3319H23.02V76.6389H39.649L31.878 89.8689H23.02V94.4999H29.158L23.02 104.949V119.636H58.943L48.86 146.759H23.02V156.681H45.172L29.19 199.676C28.8792 200.512 28.7753 201.41 28.8871 202.295C28.9988 203.179 29.3231 204.024 29.832 204.756C30.341 205.488 31.0195 206.086 31.8097 206.499C32.6 206.912 33.4784 207.127 34.37 207.127L51.809 156.684H93.516L83.577 207.127H91.527L100.153 156.684H143.003L142.44 207.127H150.39L149.64 156.684H191.728L200.166 207.127H208.116L198.365 156.684H249.982L269.242 200.59V183.845L256.619 156.681H269.238V146.759H252.008L239.408 119.637H269.238V113.684H236.638L227.723 94.5009H262.053L269.241 107.301V98.1929L267.072 94.5009L269.238 94.4999ZM82.454 68.0399H110.98L109.938 73.3319H80.625L82.454 68.0399ZM79.481 76.6399H109.286L106.679 89.8699H74.907L79.481 76.6399ZM105.768 94.4999L101.988 113.683H66.675L73.307 94.4999H105.768ZM49.031 68.0399H78.124L76.157 73.3329H46.057L49.031 68.0399ZM44.203 76.6399H74.927L70.009 89.8699H36.777L44.203 76.6399ZM23.409 113.683L34.177 94.4999H68.287L61.156 113.683H23.409ZM95.471 146.759H55.238L64.614 119.637H100.814L95.471 146.759ZM143.114 146.759H101.85L106.487 119.637H143.416L143.114 146.759ZM143.483 113.683H107.506L110.786 94.4999H143.697L143.483 113.683ZM143.748 89.8689H111.578L113.841 76.6389H143.896L143.748 89.8689ZM143.933 73.3319H114.406L115.312 68.0389H143.992L143.933 73.3319ZM247.201 68.0389L250.172 73.3319H217.888L215.428 68.0389H247.201ZM214.871 76.6389L220.671 89.8689H185.45L182.893 76.6389H214.871ZM211.099 68.0389L213.421 73.3319H182.253L181.23 68.0389H211.099ZM148.322 68.0389H176.899L177.785 73.3319H148.401L148.322 68.0389ZM148.45 76.6389H178.338L180.551 89.8689H148.651L148.45 76.6389ZM148.715 94.4999H181.326L184.536 113.683H149L148.715 94.4999ZM149.492 146.759L149.092 119.637H185.533L190.07 146.759H149.492ZM245.628 146.759H196.447L191.204 119.637H233.732L245.628 146.759ZM231.12 113.683H190.053L186.345 94.4999H222.706L231.12 113.683ZM225.572 89.8689L219.424 76.6389H252.024L259.45 89.8689H225.572Z",
    fill: "#B0B0B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.764 207.125H27.875C26.5874 207.125 25.3525 206.613 24.442 205.703C23.5315 204.792 23.02 203.558 23.02 202.27V176.525H94.138C98.0176 176.525 101.738 178.066 104.482 180.809C107.225 183.553 108.766 187.273 108.766 191.153L108.764 207.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.764 207.125H27.875C26.5874 207.125 25.3525 206.613 24.442 205.703C23.5315 204.792 23.02 203.558 23.02 202.27V176.525H94.138C98.0176 176.525 101.738 178.066 104.482 180.809C107.225 183.553 108.766 187.273 108.766 191.153L108.764 207.125Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.338 176.525H23.02V201.597C23.02 203.062 23.6022 204.468 24.6385 205.504C25.6749 206.541 27.0804 207.123 28.546 207.123H43.338V176.525Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.338 176.525H23.02V201.597C23.02 203.062 23.6022 204.468 24.6385 205.504C25.6749 206.541 27.0804 207.123 28.546 207.123H43.338V176.525Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1961 186.542V184.189L25.5231 188.62L33.1961 193.05V189.984C34.3081 190.178 35.307 190.782 35.9953 191.676C36.6836 192.571 37.0114 193.691 36.9138 194.816C36.8162 195.94 36.3003 196.988 35.4681 197.75C34.6359 198.513 33.5479 198.936 32.4191 198.935H29.6991C29.2482 198.935 28.8158 199.114 28.497 199.433C28.1782 199.752 27.9991 200.184 27.9991 200.635C27.9991 201.086 28.1782 201.518 28.497 201.837C28.8158 202.156 29.2482 202.335 29.6991 202.335H32.4181C34.4583 202.347 36.4243 201.57 37.906 200.168C39.3877 198.765 40.2708 196.845 40.371 194.807C40.4712 192.769 39.7808 190.771 38.4439 189.23C37.1069 187.689 35.2266 186.723 33.1951 186.535",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1961 186.542V184.189L25.5231 188.62L33.1961 193.05V189.984C34.3081 190.178 35.307 190.782 35.9953 191.676C36.6836 192.571 37.0114 193.691 36.9138 194.816C36.8162 195.94 36.3003 196.988 35.4681 197.75C34.6359 198.513 33.5479 198.936 32.4191 198.935H29.6991C29.2482 198.935 28.8158 199.114 28.497 199.433C28.1782 199.752 27.9991 200.184 27.9991 200.635C27.9991 201.086 28.1782 201.518 28.497 201.837C28.8158 202.156 29.2482 202.335 29.6991 202.335H32.4181C34.4583 202.347 36.4243 201.57 37.906 200.168C39.3877 198.765 40.2708 196.845 40.371 194.807C40.4712 192.769 39.7808 190.771 38.4439 189.23C37.1069 187.689 35.2266 186.723 33.1951 186.535L33.1961 186.542Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.497 207.125H260.032C262.474 207.125 264.817 206.155 266.544 204.428C268.271 202.701 269.241 200.358 269.241 197.916V176.525H198.125C196.204 176.525 194.302 176.903 192.527 177.638C190.752 178.374 189.14 179.451 187.782 180.809C186.423 182.168 185.346 183.78 184.611 185.555C183.875 187.33 183.497 189.232 183.497 191.153V207.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.497 207.125H260.032C262.474 207.125 264.817 206.155 266.544 204.428C268.271 202.701 269.241 200.358 269.241 197.916V176.525H198.125C196.204 176.525 194.302 176.903 192.527 177.638C190.752 178.374 189.14 179.451 187.782 180.809C186.423 182.168 185.346 183.78 184.611 185.555C183.875 187.33 183.497 189.232 183.497 191.153V207.125Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.238 58.1319H23.019V42.4119C23.0196 40.1401 23.9224 37.9615 25.5289 36.3551C27.1354 34.7488 29.3142 33.8462 31.586 33.8459H260.674C262.946 33.8459 265.125 34.7484 266.731 36.3548C268.338 37.9612 269.241 40.14 269.241 42.4119L269.238 58.1319Z",
    fill: "#3561E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.238 58.1319H23.019V42.4119C23.0196 40.1401 23.9224 37.9615 25.5289 36.3551C27.1354 34.7488 29.3142 33.8462 31.586 33.8459H260.674C262.946 33.8459 265.125 34.7484 266.731 36.3548C268.338 37.9612 269.241 40.14 269.241 42.4119L269.238 58.1319Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.397 72.2239H23.02V42.4129C23.02 40.141 23.9225 37.9621 25.5289 36.3555C27.1353 34.7489 29.3141 33.8462 31.586 33.8459H78.397V72.2239Z",
    fill: "#3561E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.397 72.2239H23.02V42.4129C23.02 40.141 23.9225 37.9621 25.5289 36.3555C27.1353 34.7489 29.3141 33.8462 31.586 33.8459H78.397V72.2239Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.543 185.836L59.216 187.544H58.344L59.967 179.065H61.336L62.959 187.544H62.013L61.687 185.836H59.543ZM59.664 185.025H61.554L60.597 180.131L59.664 185.025Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5872 179.065C66.9202 179.065 67.4772 179.742 67.4772 181.003V181.693C67.4772 182.626 67.1502 183.208 66.4232 183.437C67.1982 183.667 67.4892 184.298 67.4892 185.205V186.525C67.4615 186.873 67.5195 187.222 67.6582 187.542H66.7022C66.5683 187.216 66.5141 186.863 66.5442 186.512V185.18C66.5442 184.223 66.0962 183.921 65.3092 183.921H64.6422V187.542H63.6982V179.064L65.5872 179.065ZM65.3452 183.065C66.0962 183.065 66.5452 182.823 66.5452 181.903V181.091C66.5452 180.328 66.2662 179.929 65.5652 179.929H64.6432V183.066L65.3452 183.065Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3611 179.065C71.6941 179.065 72.2501 179.742 72.2501 181.003V181.693C72.2501 182.626 71.9241 183.208 71.1971 183.437C71.9721 183.667 72.2631 184.298 72.2631 185.205V186.525C72.2353 186.873 72.2933 187.222 72.4321 187.542H71.4761C71.3421 187.216 71.288 186.863 71.3181 186.512V185.18C71.3181 184.223 70.8701 183.921 70.0831 183.921H69.4161V187.542H68.4711V179.064L70.3611 179.065ZM70.1191 183.065C70.8701 183.065 71.3191 182.823 71.3191 181.903V181.091C71.3191 180.328 71.0401 179.929 70.3391 179.929H69.4171V183.066L70.1191 183.065Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1911 179.065H73.2461V187.544H74.1911V179.065Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.875 179.065L77.256 186.442L78.624 179.065H79.496L77.91 187.544H76.516L74.916 179.065H75.875Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8781 185.836L80.5511 187.544H79.6791L81.3021 179.065H82.6711L84.2941 187.544H83.3481L83.0221 185.836H80.8781ZM80.9991 185.025H82.8881L81.9311 180.131L80.9991 185.025Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0341 187.544V179.065H85.9791V186.685H88.4031V187.544H85.0341Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7711 193.734C62.7711 192.566 62.3641 192.252 61.7151 192.252C61.0661 192.252 60.6591 192.603 60.6591 193.53V194.364H58.7311V193.664C58.7311 191.588 59.7681 190.403 61.7701 190.403C63.7721 190.403 64.8091 191.589 64.8091 193.664V193.999C64.8091 195.389 64.3641 196.26 63.3821 196.668C63.8743 196.916 64.2765 197.313 64.5323 197.801C64.7882 198.289 64.885 198.846 64.8091 199.392V200.41C64.8091 202.486 63.7711 203.671 61.7701 203.671C59.7691 203.671 58.7311 202.485 58.7311 200.41V199.33H60.6581V200.53C60.6581 201.457 61.0661 201.809 61.7141 201.809C62.3621 201.809 62.7701 201.493 62.7701 200.345V199.33C62.7701 198.13 62.3631 197.68 61.4361 197.68H60.7501V195.827H61.5501C62.3101 195.827 62.7721 195.492 62.7721 194.455L62.7711 193.734Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1431 196.459H66.1791V194.495H68.1431V196.459ZM68.1431 203.519H66.1791V201.555H68.1431V203.519Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.609 192.252C71.959 192.252 71.552 192.604 71.552 193.53V194.921H69.624V193.661C69.624 191.585 70.661 190.399 72.663 190.399C74.665 190.399 75.702 191.586 75.702 193.661C75.702 197.737 71.644 199.261 71.644 201.389C71.6411 201.482 71.6471 201.575 71.662 201.667H75.517V203.521H69.624V201.927C69.624 198.109 73.664 197.479 73.664 193.735C73.664 192.568 73.257 192.253 72.609 192.253",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.795 193.66C76.795 191.584 77.889 190.398 79.89 190.398C81.891 190.398 82.985 191.585 82.985 193.66V200.41C82.985 202.486 81.891 203.671 79.89 203.671C77.889 203.671 76.795 202.481 76.795 200.41V193.66ZM78.834 200.535C78.834 201.462 79.241 201.814 79.89 201.814C80.539 201.814 80.946 201.462 80.946 200.535V193.53C80.946 192.604 80.539 192.252 79.89 192.252C79.241 192.252 78.834 192.604 78.834 193.53V200.535Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2081 193.753V195.439C93.2081 197.515 92.2081 198.645 90.1691 198.645H89.2081V203.518H87.1681V190.548H90.1681C92.2071 190.548 93.2081 191.678 93.2081 193.753ZM89.2071 192.4V196.792H90.1711C90.8201 196.792 91.1711 196.492 91.1711 195.569V193.624C91.1711 192.698 90.8201 192.401 90.1711 192.401L89.2071 192.4Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.471 199.757L99.861 190.547H102.696V203.518H100.768V194.218L99.36 203.518H97.432L95.913 194.346V203.518H94.134V190.547H96.969L98.471 199.757Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.848 181.1V181.33H198.948V181.051C198.948 180.288 198.658 179.84 197.979 179.84C197.3 179.84 197.01 180.288 197.01 181.04C197.01 182.94 199.857 183.124 199.857 185.51C199.857 186.794 199.239 187.63 197.943 187.63C196.647 187.63 196.043 186.795 196.043 185.51V185.025H196.927V185.558C196.927 186.321 197.243 186.769 197.92 186.769C198.597 186.769 198.914 186.321 198.914 185.558C198.914 183.669 196.079 183.487 196.079 181.101C196.079 179.793 196.685 178.981 197.957 178.981C199.229 178.981 199.846 179.817 199.846 181.101",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.54 179.065C203.873 179.065 204.44 179.853 204.44 181.136V182.15C204.44 183.495 203.81 184.197 202.465 184.197H201.63V187.54H200.685V179.061L202.54 179.065ZM202.467 183.352C203.167 183.352 203.508 183.026 203.508 182.215V181.088C203.508 180.313 203.229 179.926 202.539 179.926H201.631V183.35L202.467 183.352Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.196 182.82V183.668H206.125V186.684H208.669V187.543H205.181V179.064H208.669V179.925H206.125V182.825L208.196 182.82Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.556 182.82V183.668H210.486V186.684H213.03V187.543H209.542V179.064H213.03V179.925H210.486V182.825L212.556 182.82Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.89 179.065C217.21 179.065 217.815 179.865 217.815 181.172V185.45C217.815 186.75 217.215 187.55 215.89 187.55H213.903V179.072L215.89 179.065ZM215.877 186.684C216.556 186.684 216.883 186.26 216.883 185.484V181.123C216.883 180.348 216.556 179.923 215.865 179.923H214.849V186.682L215.877 186.684Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.418 192.252C198.769 192.252 198.362 192.604 198.362 193.53V194.921H196.435V193.661C196.435 191.585 197.472 190.399 199.474 190.399C201.476 190.399 202.513 191.586 202.513 193.661C202.513 197.737 198.454 199.261 198.454 201.389C198.451 201.482 198.457 201.575 198.473 201.667H202.328V203.521H196.435V201.927C196.435 198.109 200.475 197.479 200.475 193.735C200.475 192.568 200.068 192.253 199.419 192.253",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.607 199.332V200.532C205.607 201.459 206.013 201.792 206.663 201.792C207.313 201.792 207.718 201.459 207.718 200.532V197.678C207.718 196.751 207.31 196.399 206.663 196.399C206.016 196.399 205.607 196.751 205.607 197.678V198.067H203.68L204.049 190.543H209.423V192.396H205.884L205.718 195.491C205.9 195.186 206.162 194.936 206.476 194.77C206.79 194.603 207.143 194.526 207.498 194.546C208.998 194.546 209.759 195.602 209.759 197.511V200.403C209.759 202.478 208.721 203.664 206.719 203.664C204.717 203.664 203.681 202.477 203.681 200.403V199.328L205.607 199.332Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.298 199.757L219.688 190.547H222.523V203.518H220.595V194.218L219.187 203.518H217.259L215.74 194.346V203.518H213.961V190.547H216.796L218.298 199.757Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.041 203.518H224.003V190.547H226.041V196.107H228.357V190.547H230.433V203.518H228.357V197.958H226.041V203.518Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.679 77.301C255.679 75.4693 255.136 73.6787 254.118 72.1558C253.1 70.6329 251.653 69.4461 249.961 68.7454C248.268 68.0447 246.406 67.8616 244.61 68.2193C242.813 68.577 241.163 69.4594 239.868 70.7549C238.573 72.0504 237.692 73.7009 237.335 75.4975C236.978 77.2941 237.162 79.1562 237.863 80.8484C238.565 82.5405 239.752 83.9866 241.275 85.0038C242.799 86.021 244.589 86.5636 246.421 86.563C247.637 86.5631 248.842 86.3237 249.965 85.8583C251.089 85.393 252.11 84.7108 252.97 83.8508C253.83 82.9908 254.512 81.9699 254.978 80.8462C255.443 79.7225 255.682 78.5182 255.682 77.302",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.679 77.301C255.679 75.4693 255.136 73.6787 254.118 72.1558C253.1 70.6329 251.653 69.4461 249.961 68.7454C248.268 68.0447 246.406 67.8616 244.61 68.2193C242.813 68.577 241.163 69.4594 239.868 70.7549C238.573 72.0504 237.692 73.7009 237.335 75.4975C236.978 77.2941 237.162 79.1562 237.863 80.8484C238.565 82.5405 239.752 83.9866 241.275 85.0038C242.799 86.021 244.589 86.5636 246.421 86.563C247.637 86.5628 248.841 86.323 249.965 85.8574C251.088 85.3918 252.109 84.7095 252.968 83.8494C253.828 82.9894 254.51 81.9684 254.975 80.8448C255.44 79.7212 255.679 78.5171 255.679 77.301Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.419 73.9929V81.9309",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.387 77.9619H242.449",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.679 102.438C255.679 100.606 255.136 98.8158 254.118 97.2929C253.101 95.7699 251.654 94.5829 249.962 93.882C248.27 93.181 246.408 92.9976 244.611 93.355C242.815 93.7123 241.165 94.5943 239.869 95.8895C238.574 97.1847 237.692 98.8348 237.335 100.631C236.978 102.428 237.161 104.29 237.862 105.982C238.563 107.674 239.75 109.121 241.273 110.138C242.796 111.156 244.586 111.699 246.418 111.699C247.634 111.699 248.839 111.46 249.962 110.994C251.086 110.529 252.107 109.847 252.967 108.987C253.827 108.127 254.509 107.106 254.974 105.982C255.44 104.859 255.679 103.654 255.679 102.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.679 102.438C255.679 100.606 255.136 98.8158 254.118 97.2929C253.101 95.7699 251.654 94.5829 249.962 93.882C248.27 93.181 246.408 92.9976 244.611 93.355C242.815 93.7123 241.165 94.5943 239.869 95.8895C238.574 97.1847 237.692 98.8348 237.335 100.631C236.978 102.428 237.161 104.29 237.862 105.982C238.563 107.674 239.75 109.121 241.273 110.138C242.796 111.156 244.586 111.699 246.418 111.699C247.634 111.699 248.839 111.46 249.962 110.994C251.086 110.529 252.107 109.847 252.967 108.987C253.827 108.127 254.509 107.106 254.974 105.982C255.44 104.859 255.679 103.654 255.679 102.438Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.387 103.099H242.449",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.983 44.225H41.111V39.525C41.1104 39.3826 41.0723 39.2428 41.0006 39.1197C40.9289 38.9966 40.8262 38.8945 40.7026 38.8237C40.5791 38.7528 40.4391 38.7156 40.2966 38.7158C40.1542 38.7161 40.0143 38.7537 39.891 38.825L26.635 46.477C26.5112 46.5483 26.4084 46.651 26.3369 46.7747C26.2654 46.8983 26.2278 47.0387 26.2278 47.1815C26.2278 47.3244 26.2654 47.4647 26.3369 47.5884C26.4084 47.7121 26.5112 47.8147 26.635 47.886L39.89 55.539C40.0133 55.6103 40.1532 55.648 40.2956 55.6483C40.4381 55.6485 40.5781 55.6113 40.7016 55.5404C40.8252 55.4695 40.9279 55.3674 40.9996 55.2443C41.0713 55.1212 41.1094 54.9815 41.11 54.839V49.513H43.337V66.713H48.629V46.871C48.629 46.1693 48.3502 45.4963 47.854 45C47.3578 44.5038 46.6848 44.225 45.983 44.225Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.983 44.225H41.111V39.525C41.1104 39.3826 41.0723 39.2428 41.0006 39.1197C40.9289 38.9966 40.8262 38.8945 40.7026 38.8237C40.5791 38.7528 40.4391 38.7156 40.2966 38.7158C40.1542 38.7161 40.0143 38.7537 39.891 38.825L26.635 46.477C26.5112 46.5483 26.4084 46.651 26.3369 46.7747C26.2654 46.8983 26.2278 47.0387 26.2278 47.1815C26.2278 47.3244 26.2654 47.4647 26.3369 47.5884C26.4084 47.7121 26.5112 47.8147 26.635 47.886L39.89 55.539C40.0133 55.6103 40.1532 55.648 40.2956 55.6483C40.4381 55.6485 40.5781 55.6113 40.7016 55.5404C40.8252 55.4695 40.9279 55.3674 40.9996 55.2443C41.0713 55.1212 41.1094 54.9815 41.11 54.839V49.513H43.337V66.713H48.629V46.871C48.629 46.1693 48.3502 45.4963 47.854 45C47.3578 44.5038 46.6848 44.225 45.983 44.225Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0141 53.322L60.5781 40.444C60.4956 40.3014 60.3771 40.1829 60.2344 40.1006C60.0917 40.0182 59.9298 39.9749 59.7651 39.9749C59.6003 39.9749 59.4385 40.0182 59.2958 40.1006C59.153 40.1829 59.0345 40.3014 58.9521 40.444L51.5171 53.322C51.4346 53.4648 51.3911 53.6267 51.391 53.7916C51.3909 53.9565 51.4343 54.1185 51.5167 54.2613C51.5991 54.4041 51.7176 54.5227 51.8604 54.6052C52.0032 54.6876 52.1652 54.731 52.3301 54.731H57.2301V66.931H62.5221V54.731H67.2001C67.365 54.731 67.5269 54.6876 67.6697 54.6052C67.8125 54.5227 67.9311 54.4041 68.0135 54.2613C68.0959 54.1185 68.1392 53.9565 68.1392 53.7916C68.1391 53.6267 68.0966 53.4648 68.0141 53.322Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0141 53.322L60.5781 40.444C60.4956 40.3014 60.3771 40.1829 60.2344 40.1006C60.0917 40.0182 59.9298 39.9749 59.7651 39.9749C59.6003 39.9749 59.4385 40.0182 59.2958 40.1006C59.153 40.1829 59.0345 40.3014 58.9521 40.444L51.5171 53.322C51.4346 53.4648 51.3911 53.6267 51.391 53.7916C51.3909 53.9565 51.4343 54.1185 51.5167 54.2613C51.5991 54.4041 51.7176 54.5227 51.8604 54.6052C52.0032 54.6876 52.1652 54.731 52.3301 54.731H57.2301V66.931H62.5221V54.731H67.2001C67.3651 54.7312 67.5272 54.6879 67.6701 54.6055C67.813 54.5232 67.9317 54.4046 68.0142 54.2617C68.0968 54.1189 68.1402 53.9568 68.1402 53.7919C68.1401 53.6269 68.0967 53.4648 68.0141 53.322Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.264 161.973H238.481V192.402H266.264V161.973Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.264 161.973H238.481V192.402H266.264V161.973Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.469 174.821V166.341H245.414V173.961H247.837V174.82L244.469 174.821Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.496 166.341H248.551V174.82H249.496V166.341Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.59 174.808H252.678L251.273 168.062V174.821H250.449V166.342H251.769L253.162 173.113L254.508 166.342H255.827V174.821H254.927V168.002L253.59 174.808Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.746 166.341H256.801V174.82H257.746V166.341Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.939 174.821V167.202H258.377V166.341H262.435V167.202H260.87V174.821H259.939Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.654 179.843C248.654 178.675 248.247 178.361 247.598 178.361C246.949 178.361 246.542 178.712 246.542 179.639V180.473H244.615V179.773C244.615 177.697 245.652 176.512 247.654 176.512C249.656 176.512 250.693 177.698 250.693 179.773V180.108C250.693 181.498 250.248 182.369 249.267 182.777C249.759 183.026 250.161 183.422 250.417 183.91C250.673 184.399 250.769 184.955 250.693 185.501V186.52C250.693 188.596 249.655 189.781 247.654 189.781C245.653 189.781 244.615 188.595 244.615 186.52V185.445H246.542V186.645C246.542 187.572 246.95 187.924 247.598 187.924C248.246 187.924 248.654 187.608 248.654 186.46V185.441C248.654 184.241 248.247 183.791 247.32 183.791H246.634V181.938H247.434C248.194 181.938 248.656 181.603 248.656 180.566L248.654 179.843Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.895 179.768C251.895 177.692 252.989 176.507 254.99 176.507C256.991 176.507 258.085 177.693 258.085 179.768V186.514C258.085 188.59 256.991 189.775 254.99 189.775C252.989 189.775 251.895 188.589 251.895 186.514V179.768ZM253.934 186.644C253.934 187.571 254.341 187.923 254.99 187.923C255.639 187.923 256.046 187.571 256.046 186.644V179.639C256.046 178.712 255.639 178.361 254.99 178.361C254.341 178.361 253.934 178.712 253.934 179.639V186.644Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.389 207.124L148.999 113.683H91.887L92.845 109.001L75.818 117.317L89.281 126.425L90.67 119.636H143.416L142.44 207.124H150.389Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.389 207.124L148.999 113.683H91.887L92.845 109.001L75.818 117.317L89.281 126.425L90.67 119.636H143.416L142.44 207.124H150.389Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.531 105.975C67.256 105.639 62.231 107.542 60.301 110.226C58.371 112.91 61.901 119.388 61.901 119.388C61.901 119.388 73.856 114.126 75.783 111.442C77.71 108.758 75.806 106.31 71.531 105.975ZM66.647 112.775C64.936 112.64 64.176 111.662 64.947 110.588C65.5191 109.984 66.2204 109.518 66.9983 109.223C67.7761 108.929 68.6106 108.814 69.439 108.888C71.15 109.023 71.911 110.002 71.139 111.075C70.5673 111.679 69.8661 112.146 69.0881 112.44C68.3101 112.735 67.4755 112.849 66.647 112.775Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9031 91.126C60.581 91.1258 59.2719 91.3861 58.0504 91.892C56.829 92.3979 55.7192 93.1394 54.7843 94.0742C53.8495 95.0091 53.108 96.1189 52.6021 97.3403C52.0962 98.5618 51.8359 99.8709 51.8361 101.193C51.8361 106.752 61.9031 118.91 61.9031 118.91C61.9031 118.91 71.9701 106.752 71.9701 101.193C71.9702 99.8709 71.7099 98.5618 71.204 97.3403C70.6982 96.1189 69.9566 95.0091 69.0218 94.0742C68.087 93.1394 66.9771 92.3979 65.7557 91.892C64.5342 91.3861 63.2251 91.1258 61.9031 91.126ZM61.9031 105.218C61.1065 105.218 60.3278 104.982 59.6654 104.54C59.003 104.097 58.4867 103.468 58.1818 102.733C57.8769 101.997 57.797 101.187 57.9524 100.406C58.1077 99.6243 58.4913 98.9067 59.0545 98.3435C59.6178 97.7802 60.3354 97.3967 61.1167 97.2413C61.8979 97.086 62.7077 97.1658 63.4436 97.4707C64.1795 97.7756 64.8084 98.2919 65.2508 98.9543C65.6932 99.6167 65.9293 100.395 65.9291 101.192C65.9288 102.26 65.5045 103.284 64.7496 104.038C63.9946 104.793 62.9707 105.218 61.9031 105.218Z",
    fill: "#3561E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9031 91.126C60.581 91.1258 59.2719 91.3861 58.0504 91.892C56.829 92.3979 55.7192 93.1394 54.7843 94.0742C53.8495 95.0091 53.108 96.1189 52.6021 97.3403C52.0962 98.5618 51.8359 99.8709 51.8361 101.193C51.8361 106.752 61.9031 118.91 61.9031 118.91C61.9031 118.91 71.9701 106.752 71.9701 101.193C71.9702 99.8709 71.7099 98.5618 71.204 97.3403C70.6982 96.1189 69.9566 95.0091 69.0218 94.0742C68.087 93.1394 66.9771 92.3979 65.7557 91.892C64.5342 91.3861 63.2251 91.1258 61.9031 91.126ZM61.9031 105.218C61.1065 105.218 60.3278 104.982 59.6654 104.54C59.003 104.097 58.4867 103.468 58.1818 102.733C57.8769 101.997 57.797 101.187 57.9524 100.406C58.1077 99.6243 58.4913 98.9067 59.0545 98.3435C59.6178 97.7802 60.3354 97.3967 61.1167 97.2413C61.8979 97.086 62.7077 97.1658 63.4436 97.4707C64.1795 97.7756 64.8084 98.2919 65.2508 98.9543C65.6932 99.6167 65.9293 100.395 65.9291 101.192C65.9291 102.26 65.5049 103.284 64.7499 104.039C63.9949 104.794 62.9709 105.218 61.9031 105.218Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.532 164.704L128.847 195.34H164.217L146.532 164.704Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.032 207.125H27.874C27.2365 207.125 26.6052 206.999 26.0162 206.755C25.4273 206.511 24.8921 206.154 24.4414 205.703C23.9906 205.252 23.6331 204.717 23.3892 204.128C23.1453 203.539 23.0199 202.907 23.02 202.27V42.4129C23.02 40.141 23.9225 37.9621 25.5289 36.3555C27.1353 34.7489 29.3141 33.8462 31.586 33.8459H260.675C262.946 33.847 265.124 34.7501 266.73 36.3566C268.336 37.9631 269.238 40.1415 269.238 42.4129V197.913C269.238 199.122 269.001 200.32 268.538 201.437C268.076 202.555 267.398 203.57 266.543 204.426C265.688 205.281 264.673 205.96 263.556 206.423C262.439 206.886 261.241 207.125 260.032 207.125Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_644_4520",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 747,
    height: 476
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M746.522 0H0V475.626H746.522V0Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_644_4520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M532.769 437.753C532.769 434.405 531.776 431.132 529.916 428.348C528.056 425.564 525.412 423.394 522.318 422.113C519.225 420.831 515.821 420.496 512.537 421.149C509.253 421.802 506.237 423.415 503.869 425.782C501.502 428.15 499.89 431.166 499.236 434.45C498.583 437.734 498.918 441.138 500.2 444.231C501.481 447.325 503.651 449.969 506.435 451.829C509.219 453.689 512.492 454.682 515.84 454.682C520.33 454.682 524.636 452.898 527.811 449.724C530.985 446.549 532.769 442.243 532.769 437.753Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.769 437.753C532.769 434.405 531.776 431.132 529.916 428.348C528.056 425.564 525.412 423.394 522.318 422.113C519.225 420.831 515.821 420.496 512.537 421.149C509.253 421.802 506.237 423.415 503.869 425.782C501.502 428.15 499.89 431.166 499.236 434.45C498.583 437.734 498.918 441.138 500.2 444.231C501.481 447.325 503.651 449.969 506.435 451.829C509.219 453.689 512.492 454.682 515.84 454.682C520.33 454.682 524.636 452.898 527.811 449.724C530.985 446.549 532.769 442.243 532.769 437.753Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.661 437.753C528.661 435.218 527.909 432.739 526.5 430.631C525.091 428.523 523.089 426.88 520.747 425.91C518.404 424.94 515.826 424.686 513.34 425.18C510.853 425.675 508.569 426.896 506.776 428.689C504.983 430.482 503.762 432.766 503.267 435.253C502.773 437.74 503.026 440.317 503.997 442.66C504.967 445.002 506.61 447.004 508.718 448.413C510.826 449.822 513.305 450.574 515.84 450.574C519.24 450.574 522.501 449.223 524.906 446.819C527.31 444.414 528.661 441.153 528.661 437.753Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.661 437.753C528.661 435.218 527.909 432.739 526.5 430.631C525.091 428.523 523.089 426.88 520.747 425.91C518.404 424.94 515.826 424.686 513.34 425.18C510.853 425.675 508.569 426.896 506.776 428.689C504.983 430.482 503.762 432.766 503.267 435.253C502.773 437.74 503.026 440.317 503.997 442.66C504.967 445.002 506.61 447.004 508.718 448.413C510.826 449.822 513.305 450.574 515.84 450.574C519.24 450.574 522.501 449.223 524.906 446.819C527.31 444.414 528.661 441.153 528.661 437.753Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.484 442.638L527.184 443.717C527.597 442.931 527.926 442.104 528.166 441.249L523.277 438.126C523.174 438.06 523.088 437.971 523.025 437.866C522.963 437.761 522.926 437.642 522.917 437.52C522.909 437.398 522.929 437.276 522.976 437.163C523.023 437.05 523.095 436.95 523.188 436.87L527.728 432.964C527.408 432.168 527.009 431.406 526.536 430.69L520.776 432.656C520.66 432.696 520.537 432.707 520.416 432.691C520.295 432.674 520.179 432.629 520.078 432.56C519.978 432.491 519.894 432.399 519.836 432.292C519.777 432.185 519.744 432.065 519.739 431.943L519.497 425.469C518.735 425.24 517.954 425.083 517.163 425L514.941 431.2C514.899 431.314 514.832 431.417 514.744 431.501C514.655 431.585 514.549 431.647 514.432 431.682C514.316 431.718 514.193 431.726 514.073 431.706C513.953 431.685 513.839 431.638 513.741 431.566L508.201 427.477C507.602 427.923 507.042 428.42 506.528 428.962L510.169 434.854C510.233 434.958 510.273 435.076 510.283 435.198C510.294 435.32 510.276 435.442 510.231 435.556C510.186 435.67 510.115 435.771 510.023 435.853C509.932 435.934 509.822 435.993 509.704 436.024L503.028 437.811C503.034 438.561 503.105 439.31 503.242 440.048L510.048 440.868C510.17 440.882 510.286 440.925 510.388 440.993C510.49 441.06 510.575 441.15 510.636 441.257C510.696 441.363 510.732 441.482 510.738 441.604C510.745 441.726 510.723 441.848 510.674 441.96L508.074 447.928C508.713 448.417 509.397 448.845 510.116 449.206L514.68 444.706C514.767 444.62 514.873 444.556 514.989 444.518C515.106 444.481 515.229 444.471 515.35 444.49C515.471 444.508 515.586 444.555 515.685 444.626C515.785 444.697 515.866 444.791 515.923 444.899L518.739 450.228C519.582 450.033 520.402 449.753 521.188 449.392L520.568 443.486C520.555 443.364 520.571 443.241 520.614 443.127C520.657 443.012 520.727 442.909 520.817 442.827C520.907 442.744 521.015 442.683 521.132 442.649C521.25 442.616 521.374 442.61 521.494 442.633",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.484 442.638L527.184 443.717C527.597 442.931 527.926 442.104 528.166 441.249L523.277 438.126C523.174 438.06 523.088 437.971 523.025 437.866C522.963 437.761 522.926 437.642 522.917 437.52C522.909 437.398 522.929 437.276 522.976 437.163C523.023 437.05 523.095 436.95 523.188 436.87L527.728 432.964C527.408 432.168 527.009 431.406 526.536 430.69L520.776 432.656C520.66 432.696 520.537 432.707 520.416 432.691C520.295 432.674 520.179 432.629 520.078 432.56C519.978 432.491 519.894 432.399 519.836 432.292C519.777 432.185 519.744 432.065 519.739 431.943L519.497 425.469C518.735 425.24 517.954 425.083 517.163 425L514.941 431.2C514.899 431.314 514.832 431.417 514.744 431.501C514.655 431.585 514.549 431.647 514.432 431.682C514.316 431.718 514.193 431.726 514.073 431.706C513.953 431.685 513.839 431.638 513.741 431.566L508.201 427.477C507.602 427.923 507.042 428.42 506.528 428.962L510.169 434.854C510.233 434.958 510.273 435.076 510.283 435.198C510.294 435.32 510.276 435.442 510.231 435.556C510.186 435.67 510.115 435.771 510.023 435.853C509.932 435.934 509.822 435.993 509.704 436.024L503.028 437.811C503.034 438.561 503.105 439.31 503.242 440.048L510.048 440.868C510.17 440.882 510.286 440.925 510.388 440.993C510.49 441.06 510.575 441.15 510.636 441.257C510.696 441.363 510.732 441.482 510.738 441.604C510.745 441.726 510.723 441.848 510.674 441.96L508.074 447.928C508.713 448.417 509.397 448.845 510.116 449.206L514.68 444.706C514.767 444.62 514.873 444.556 514.989 444.518C515.106 444.481 515.229 444.471 515.35 444.49C515.471 444.508 515.586 444.555 515.685 444.626C515.785 444.697 515.866 444.791 515.923 444.899L518.739 450.228C519.582 450.033 520.402 449.753 521.188 449.392L520.568 443.486C520.556 443.366 520.573 443.244 520.616 443.131C520.659 443.018 520.727 442.917 520.816 442.835C520.904 442.753 521.011 442.692 521.127 442.658C521.243 442.624 521.365 442.617 521.484 442.638Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.706 295.494L522.43 307.332C523.112 307.88 523.651 308.584 524.002 309.385C524.353 310.186 524.505 311.06 524.445 311.932L515.845 437.752",
    stroke: "#263238",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.489 191.25C561.489 191.25 559.663 196.562 560.328 198.055C560.856 199.37 561.028 200.802 560.828 202.205C560.662 202.705 557.508 208.347 557.84 209.011C558.172 209.675 561.658 211.832 561.658 211.832C561.658 211.832 565.808 221.132 567.136 220.962C568.464 220.792 575.104 217.642 575.104 217.642L576.104 226.605L589.051 221.293L593.201 202.536C593.201 202.536 593.367 195.564 582.577 190.916C571.787 186.268 562.658 188.925 561.496 191.248",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.489 191.25C561.489 191.25 559.663 196.562 560.328 198.055C560.856 199.371 561.028 200.802 560.828 202.205C560.662 202.705 557.508 208.347 557.84 209.011C558.172 209.675 561.658 211.832 561.658 211.832C561.658 211.832 565.808 221.132 567.136 220.962C568.464 220.792 575.104 217.642 575.104 217.642L576.104 226.605L589.051 221.293L593.201 202.536C593.201 202.536 593.367 195.564 582.577 190.916C571.787 186.268 562.65 188.926 561.489 191.25Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.974 212.83C564.974 212.83 567.464 213.66 568.46 210.34",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.485 199.384C562.485 199.384 564.144 197.393 565.804 199.218",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.301 202.709C565.401 203.574 565.191 204.309 564.827 204.353C564.463 204.397 564.085 203.729 563.982 202.864C563.879 201.999 564.092 201.264 564.456 201.221C564.82 201.178 565.199 201.844 565.301 202.709Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.48 283.045L515.342 288.523C515.342 288.523 505.05 286.365 504.22 286.365C503.39 286.365 503.556 288.356 503.556 288.356C503.556 288.356 500.236 294.664 500.568 295.494C500.9 296.324 503.888 299.478 504.219 298.814C504.632 297.929 504.692 296.92 504.385 295.993C504.053 294.664 507.373 292.839 507.373 292.839C507.373 292.839 514.673 295.163 517.167 295.163C519.661 295.163 524.305 291.51 524.305 291.51L530.114 285.701L523.972 281.551L522.48 283.045Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.063 334.826C558.063 334.826 559.082 366.059 560.324 369.058C564.198 378.423 600.368 411.686 601.982 413.301C603.596 414.916 601.013 421.375 601.013 422.343C601.013 423.311 599.398 426.864 596.171 429.125C595.255 429.783 594.566 430.709 594.199 431.776C593.832 432.842 593.806 433.997 594.123 435.079C595.776 435.005 597.433 435.066 599.076 435.261C601.983 435.584 606.505 435.261 607.476 432.354C608.39 429.204 610.053 426.322 612.322 423.954C614.904 421.371 619.103 421.371 618.78 416.204C618.457 411.037 613.29 409.745 610.706 406.192C608.122 402.639 594.236 387.139 590.362 379.392C586.488 371.645 576.153 362.922 576.153 362.922L578.082 335.148L558.063 334.826Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.063 334.826C558.063 334.826 559.082 366.059 560.324 369.058C564.198 378.423 600.368 411.686 601.982 413.301C603.596 414.916 601.013 421.375 601.013 422.343C601.013 423.311 599.398 426.864 596.171 429.125C595.255 429.783 594.566 430.709 594.199 431.776C593.832 432.842 593.806 433.997 594.123 435.079C595.776 435.005 597.433 435.066 599.076 435.261C601.983 435.584 606.505 435.261 607.476 432.354C608.39 429.204 610.053 426.322 612.322 423.954C614.904 421.371 619.103 421.371 618.78 416.204C618.457 411.037 613.29 409.745 610.706 406.192C608.122 402.639 594.236 387.139 590.362 379.392C586.488 371.645 576.153 362.922 576.153 362.922L578.082 335.148L558.063 334.826Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.253 408.73C612.799 409.892 612.265 411.142 611.671 412.33C611.097 413.467 610.277 414.461 609.272 415.243C608.267 416.025 607.101 416.574 605.858 416.851L604.243 415.559C603.76 415.15 603.136 414.947 602.504 414.992C602.566 417.526 601.013 421.592 601.013 422.341C601.013 423.31 599.398 426.861 596.169 429.122C595.254 429.781 594.565 430.707 594.198 431.774C593.832 432.841 593.805 433.995 594.122 435.077C595.776 435.003 597.433 435.064 599.076 435.258C601.983 435.581 606.504 435.258 607.476 432.351C608.39 429.202 610.052 426.32 612.319 423.951C614.903 421.368 619.101 421.368 618.778 416.201C618.543 412.449 615.756 410.738 613.256 408.723",
    fill: "#3561E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.253 408.73C612.799 409.892 612.265 411.142 611.671 412.33C611.097 413.466 610.277 414.461 609.272 415.243C608.267 416.025 607.101 416.574 605.858 416.851L604.243 415.559C603.76 415.15 603.136 414.947 602.504 414.992C602.566 417.526 601.013 421.592 601.013 422.341C601.013 423.31 599.398 426.861 596.169 429.122C595.254 429.781 594.565 430.707 594.198 431.774C593.832 432.84 593.805 433.995 594.122 435.077C595.776 435.003 597.433 435.063 599.076 435.258C601.983 435.581 606.504 435.258 607.476 432.351C608.39 429.202 610.052 426.32 612.319 423.951C614.903 421.368 619.101 421.368 618.778 416.201C618.54 412.455 615.753 410.745 613.253 408.73Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.221 331.96C574.221 331.96 576.398 350.36 577.981 355.505C578.864 358.298 579.591 361.139 580.157 364.014C580.157 364.014 580.357 380.832 583.126 388.549C585.895 396.266 584.708 420.136 584.708 420.729C584.708 421.322 581.74 425.478 578.179 427.456C574.618 429.434 567.296 431.809 567.296 432.996C567.24 433.595 567.413 434.194 567.78 434.671C568.147 435.148 568.681 435.469 569.275 435.568C570.66 435.768 579.366 436.162 584.114 436.162C588.862 436.162 595.392 434.381 596.381 433.788C597.37 433.195 596.581 430.226 596.181 427.258C595.781 424.29 596.181 408.136 596.181 408.136C596.181 408.136 598.358 393.494 598.16 382.81C597.962 372.126 594.202 360.65 594.202 360.65C594.202 360.65 595.39 333.543 595.983 332.158C596.576 330.773 574.218 331.958 574.218 331.958",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.221 331.96C574.221 331.96 576.398 350.36 577.981 355.505C578.864 358.299 579.591 361.139 580.157 364.014C580.157 364.014 580.357 380.832 583.126 388.549C585.895 396.266 584.708 420.136 584.708 420.729C584.708 421.322 581.74 425.478 578.179 427.456C574.618 429.434 567.296 431.809 567.296 432.996C567.24 433.595 567.413 434.194 567.78 434.671C568.147 435.148 568.681 435.469 569.275 435.568C570.66 435.768 579.366 436.162 584.114 436.162C588.862 436.162 595.392 434.381 596.381 433.788C597.37 433.195 596.581 430.226 596.181 427.258C595.781 424.29 596.181 408.136 596.181 408.136C596.181 408.136 598.358 393.494 598.16 382.81C597.962 372.126 594.202 360.65 594.202 360.65C594.202 360.65 595.39 333.543 595.983 332.158C596.576 330.773 574.221 331.96 574.221 331.96Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.382 433.788C597.371 433.195 596.582 430.227 596.182 427.258C596.119 426.786 596.076 426.058 596.048 425.168C593.142 426.031 590.086 426.272 587.08 425.874C587.08 424.791 586.879 423.717 586.487 422.707C586.052 421.921 585.443 421.244 584.706 420.729C584.706 421.322 581.738 425.478 578.177 427.457C574.616 429.436 567.294 431.809 567.294 432.997C567.238 433.596 567.411 434.195 567.778 434.672C568.145 435.149 568.679 435.47 569.273 435.569C570.658 435.769 579.364 436.162 584.112 436.162C588.86 436.162 595.39 434.381 596.379 433.788",
    fill: "#3561E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.382 433.788C597.371 433.195 596.582 430.227 596.182 427.258C596.119 426.786 596.076 426.058 596.048 425.168C593.142 426.031 590.086 426.272 587.08 425.874C587.08 424.791 586.879 423.717 586.487 422.707C586.052 421.921 585.443 421.244 584.706 420.729C584.706 421.322 581.738 425.478 578.177 427.457C574.616 429.436 567.294 431.809 567.294 432.997C567.238 433.596 567.411 434.195 567.778 434.672C568.145 435.149 568.679 435.47 569.273 435.569C570.658 435.769 579.364 436.162 584.112 436.162C588.86 436.162 595.393 434.382 596.382 433.788Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.184 290.608L543.949 331.169C543.949 331.169 554.435 339.084 574.221 339.084C594.007 339.084 615.574 329.584 615.574 329.584L601.328 291.001C601.328 291.001 577.189 285.066 559.184 290.601",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.184 290.608L543.949 331.169C543.949 331.169 554.435 339.084 574.221 339.084C594.007 339.084 615.574 329.584 615.574 329.584L601.328 291.001C601.328 291.001 577.184 285.068 559.184 290.608Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.152 294.961L557.008 312.175",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.922 297.929L560.173 323.452",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.243 294.565L571.056 305.051",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.777 296.148L600.735 309.999",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.598 225.446C574.611 225.642 573.675 226.037 572.847 226.608C572.02 227.179 571.317 227.913 570.784 228.766C568.793 231.754 522.484 283.046 522.484 283.046C524.009 284.264 525.617 285.374 527.298 286.366C528.134 286.817 529.028 287.153 529.954 287.366L533.605 285.374C533.605 285.374 553.026 284.374 557.176 283.05C557.176 283.05 554.355 291.35 555.018 292.014C555.681 292.678 558.006 294.835 560.164 295.002C562.322 295.169 568.964 293.841 568.964 293.841C568.964 293.841 585.398 296.165 591.042 296.165C596.686 296.165 600.669 295.003 601.831 294.006C602.993 293.009 605.649 289.524 605.981 286.706C606.313 283.888 599.008 263.466 599.838 261.474C600.668 259.482 603.323 245.035 601.162 235.405C599.001 225.775 593.862 226.105 590.538 223.952C587.214 221.799 575.598 225.446 575.598 225.446Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.598 225.446C574.611 225.642 573.675 226.037 572.847 226.608C572.02 227.179 571.317 227.913 570.784 228.766C568.793 231.754 522.484 283.046 522.484 283.046C524.009 284.264 525.617 285.374 527.298 286.366C528.134 286.817 529.028 287.153 529.954 287.366L533.605 285.374C533.605 285.374 553.026 284.374 557.176 283.05C557.176 283.05 554.355 291.35 555.018 292.014C555.681 292.678 558.006 294.835 560.164 295.002C562.322 295.169 568.964 293.841 568.964 293.841C568.964 293.841 585.398 296.165 591.042 296.165C596.686 296.165 600.669 295.003 601.831 294.006C602.993 293.009 605.649 289.524 605.981 286.706C606.313 283.888 599.008 263.466 599.838 261.474C600.668 259.482 603.323 245.035 601.162 235.405C599.001 225.775 593.862 226.105 590.538 223.952C587.214 221.799 575.598 225.446 575.598 225.446Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.173 283.045C557.173 283.045 570.785 280.887 573.606 278.895C576.427 276.903 592.529 250.676 592.529 250.676",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.986 286.559C592.108 286.365 593.525 286.365 593.525 286.365",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.958 293.836C568.958 293.836 583.897 287.362 587.384 286.864",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.497 271.642C570.229 270.929 571.997 270.142 573.776 269.268",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.566 278.231C550.438 277.434 558.171 275.606 565.566 272.792",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.913 276.571C545.822 275.921 552.564 274.069 558.835 271.098",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.131 279.56C527.778 281.536 529.973 282.98 532.439 283.71",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.712 257.317L595.186 251.175",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.894 223.951C584.894 223.951 595.518 232.085 598.34 235.736C601.162 239.387 601.162 249.68 602.324 249.845C603.486 250.01 612.449 243.703 613.778 239.222C615.107 234.741 605.478 229.096 599.668 226.274C593.858 223.452 586.222 221.959 584.895 223.95",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.894 223.951C584.894 223.951 595.518 232.085 598.34 235.736C601.162 239.387 601.162 249.68 602.324 249.845C603.486 250.01 612.449 243.703 613.778 239.222C615.107 234.741 605.478 229.096 599.668 226.274C593.858 223.452 586.222 221.96 584.894 223.951Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.44 195.736C573.44 195.736 572.776 201.048 574.602 205.198C576.428 209.348 579.416 214.162 578.917 218.312C578.418 222.462 572.278 224.121 572.278 224.121C572.278 224.121 573.772 228.105 577.091 229.433C580.41 230.761 584.891 227.442 584.891 227.442L584.391 230.098C587.764 230.258 591.138 229.808 594.351 228.769C598.666 227.109 600.326 221.964 599.33 216.652C598.334 211.34 594.848 208.518 594.018 205.53C593.787 204.625 593.757 203.681 593.93 202.763C594.102 201.845 594.474 200.976 595.018 200.217C595.018 200.217 593.192 195.238 585.39 192.084C577.588 188.93 574.601 192.914 573.438 195.735",
    fill: "#3561E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.44 195.736C573.44 195.736 572.776 201.048 574.602 205.198C576.428 209.348 579.416 214.162 578.917 218.312C578.418 222.462 572.278 224.121 572.278 224.121C572.278 224.121 573.772 228.105 577.091 229.433C580.41 230.761 584.891 227.442 584.891 227.442L584.391 230.098C587.764 230.258 591.138 229.808 594.351 228.769C598.666 227.109 600.326 221.964 599.33 216.652C598.334 211.34 594.848 208.518 594.018 205.53C593.787 204.625 593.757 203.681 593.93 202.763C594.102 201.845 594.474 200.976 595.018 200.217C595.018 200.217 593.192 195.238 585.39 192.084C577.588 188.93 574.603 192.91 573.44 195.736Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.926 198.056C576.926 198.056 578.254 211.169 574.27 219.303",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.5 192.91C558.5 192.91 563.479 192.91 566.467 194.736C569.455 196.562 571.281 199.051 574.435 198.886C577.589 198.721 580.08 196.23 582.735 197.557C583.773 197.996 584.675 198.705 585.346 199.61C586.018 200.514 586.435 201.583 586.554 202.703C586.718 204.528 587.217 205.857 589.375 206.354C591.109 206.792 592.9 206.961 594.685 206.854C595.35 206.689 598.67 201.542 599.665 194.902C600.66 188.262 595.515 178.302 583.565 175.315C571.615 172.328 557.337 179.133 558.5 192.915",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.5 192.91C558.5 192.91 563.479 192.91 566.467 194.736C569.455 196.562 571.281 199.051 574.435 198.886C577.589 198.721 580.08 196.23 582.735 197.557C583.773 197.996 584.674 198.705 585.346 199.61C586.017 200.514 586.435 201.583 586.554 202.703C586.718 204.528 587.217 205.857 589.375 206.354C591.109 206.792 592.9 206.961 594.685 206.854C595.35 206.689 598.67 201.542 599.665 194.902C600.66 188.262 595.515 178.302 583.565 175.315C571.615 172.328 557.338 179.13 558.5 192.91Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.861 295.495C510.861 294.871 510.676 294.261 510.329 293.743C509.983 293.224 509.49 292.82 508.914 292.581C508.338 292.342 507.703 292.28 507.092 292.402C506.48 292.523 505.918 292.824 505.477 293.265C505.036 293.706 504.735 294.268 504.614 294.88C504.492 295.492 504.554 296.126 504.793 296.702C505.032 297.278 505.436 297.771 505.955 298.118C506.473 298.464 507.083 298.649 507.707 298.649C508.121 298.649 508.531 298.568 508.914 298.409C509.297 298.251 509.645 298.018 509.937 297.726C510.23 297.433 510.463 297.085 510.621 296.702C510.78 296.319 510.861 295.909 510.861 295.495Z",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.706 298.649C509.448 298.649 510.86 297.237 510.86 295.495C510.86 293.753 509.448 292.341 507.706 292.341C505.964 292.341 504.552 293.753 504.552 295.495C504.552 297.237 505.964 298.649 507.706 298.649Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.868 437.753C672.868 434.405 671.875 431.132 670.015 428.348C668.155 425.564 665.511 423.394 662.417 422.113C659.324 420.831 655.92 420.496 652.636 421.149C649.352 421.802 646.336 423.415 643.968 425.782C641.601 428.15 639.989 431.166 639.335 434.45C638.682 437.734 639.017 441.138 640.299 444.231C641.58 447.325 643.75 449.969 646.534 451.829C649.318 453.689 652.591 454.682 655.939 454.682C660.429 454.682 664.735 452.898 667.91 449.724C671.084 446.549 672.868 442.243 672.868 437.753Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.868 437.753C672.868 434.405 671.875 431.132 670.015 428.348C668.155 425.564 665.511 423.394 662.417 422.113C659.324 420.831 655.92 420.496 652.636 421.149C649.352 421.802 646.336 423.415 643.968 425.782C641.601 428.15 639.989 431.166 639.335 434.45C638.682 437.734 639.017 441.138 640.299 444.231C641.58 447.325 643.75 449.969 646.534 451.829C649.318 453.689 652.591 454.682 655.939 454.682C660.429 454.682 664.735 452.898 667.91 449.724C671.084 446.549 672.868 442.243 672.868 437.753Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.759 437.753C668.759 435.218 668.007 432.739 666.598 430.631C665.189 428.523 663.187 426.88 660.845 425.91C658.502 424.94 655.924 424.686 653.438 425.18C650.951 425.675 648.667 426.896 646.874 428.689C645.081 430.482 643.86 432.766 643.365 435.253C642.871 437.74 643.125 440.317 644.095 442.66C645.065 445.002 646.708 447.004 648.816 448.413C650.924 449.822 653.403 450.574 655.938 450.574C659.338 450.574 662.599 449.223 665.004 446.819C667.408 444.414 668.759 441.153 668.759 437.753Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.759 437.753C668.759 435.218 668.007 432.739 666.598 430.631C665.189 428.523 663.187 426.88 660.845 425.91C658.502 424.94 655.924 424.686 653.438 425.18C650.951 425.675 648.667 426.896 646.874 428.689C645.081 430.482 643.86 432.766 643.365 435.253C642.871 437.74 643.125 440.317 644.095 442.66C645.065 445.002 646.708 447.004 648.816 448.413C650.924 449.822 653.403 450.574 655.938 450.574C659.338 450.574 662.599 449.223 665.004 446.819C667.408 444.414 668.759 441.153 668.759 437.753Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.585 442.638L667.285 443.717C667.698 442.931 668.027 442.104 668.267 441.249L663.378 438.126C663.275 438.06 663.189 437.971 663.126 437.866C663.064 437.761 663.027 437.642 663.018 437.52C663.01 437.398 663.03 437.276 663.077 437.163C663.124 437.05 663.196 436.95 663.289 436.87L667.829 432.964C667.509 432.168 667.11 431.406 666.637 430.69L660.877 432.656C660.761 432.696 660.638 432.707 660.517 432.691C660.396 432.674 660.28 432.629 660.179 432.56C660.079 432.491 659.995 432.399 659.936 432.292C659.878 432.185 659.845 432.065 659.84 431.943L659.598 425.469C658.836 425.24 658.055 425.083 657.264 425L655.042 431.2C655 431.314 654.933 431.417 654.845 431.501C654.756 431.585 654.65 431.647 654.533 431.682C654.417 431.718 654.294 431.726 654.174 431.706C654.054 431.685 653.94 431.638 653.842 431.566L648.303 427.477C647.703 427.923 647.143 428.419 646.629 428.962L650.27 434.854C650.334 434.958 650.374 435.076 650.384 435.198C650.395 435.32 650.377 435.442 650.332 435.556C650.287 435.67 650.215 435.771 650.124 435.853C650.032 435.934 649.923 435.993 649.805 436.024L643.129 437.811C643.135 438.561 643.206 439.31 643.343 440.048L650.149 440.868C650.271 440.882 650.387 440.925 650.489 440.993C650.591 441.06 650.676 441.15 650.737 441.257C650.797 441.363 650.833 441.482 650.839 441.604C650.846 441.726 650.824 441.848 650.775 441.96L648.175 447.928C648.814 448.417 649.498 448.845 650.217 449.206L654.781 444.706C654.868 444.62 654.974 444.556 655.09 444.518C655.207 444.481 655.33 444.471 655.451 444.49C655.572 444.508 655.687 444.555 655.786 444.626C655.886 444.697 655.967 444.791 656.024 444.899L658.84 450.228C659.683 450.033 660.503 449.753 661.289 449.392L660.669 443.486C660.656 443.364 660.672 443.241 660.715 443.127C660.758 443.012 660.827 442.909 660.917 442.827C661.007 442.744 661.116 442.683 661.233 442.649C661.351 442.616 661.475 442.61 661.595 442.633",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.585 442.638L667.285 443.717C667.698 442.931 668.027 442.104 668.267 441.249L663.378 438.126C663.275 438.06 663.189 437.971 663.126 437.866C663.064 437.761 663.027 437.642 663.018 437.52C663.01 437.398 663.03 437.276 663.077 437.163C663.124 437.05 663.196 436.95 663.289 436.87L667.829 432.964C667.509 432.168 667.11 431.406 666.637 430.69L660.877 432.656C660.761 432.696 660.638 432.707 660.517 432.691C660.396 432.674 660.28 432.629 660.179 432.56C660.079 432.491 659.995 432.399 659.936 432.292C659.878 432.185 659.845 432.065 659.84 431.943L659.598 425.469C658.836 425.24 658.055 425.083 657.264 425L655.042 431.2C655 431.314 654.933 431.417 654.845 431.501C654.756 431.585 654.65 431.647 654.533 431.682C654.417 431.718 654.294 431.726 654.174 431.706C654.054 431.685 653.94 431.638 653.842 431.566L648.303 427.477C647.703 427.923 647.143 428.419 646.629 428.962L650.27 434.854C650.334 434.958 650.374 435.076 650.384 435.198C650.395 435.32 650.377 435.442 650.332 435.556C650.287 435.67 650.215 435.771 650.124 435.853C650.032 435.934 649.923 435.993 649.805 436.024L643.129 437.811C643.135 438.561 643.206 439.31 643.343 440.048L650.149 440.868C650.271 440.882 650.387 440.925 650.489 440.993C650.591 441.06 650.676 441.15 650.737 441.257C650.797 441.363 650.833 441.482 650.839 441.604C650.846 441.726 650.824 441.848 650.775 441.96L648.175 447.928C648.814 448.417 649.498 448.845 650.217 449.206L654.781 444.706C654.868 444.62 654.974 444.556 655.09 444.518C655.207 444.481 655.33 444.471 655.451 444.49C655.572 444.508 655.687 444.555 655.786 444.626C655.886 444.697 655.967 444.791 656.024 444.899L658.84 450.228C659.683 450.033 660.503 449.753 661.289 449.392L660.669 443.486C660.657 443.366 660.674 443.244 660.717 443.131C660.76 443.018 660.828 442.917 660.917 442.835C661.005 442.753 661.112 442.692 661.228 442.658C661.344 442.624 661.466 442.617 661.585 442.638Z",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.29 393.205L552.45 437.943H660.098",
    stroke: "#263238",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.34 375.776L515.537 388.778L523.232 389.254L524.036 376.251L516.34 375.776Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_644_4520",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 747,
    height: 476
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M746.522 0H0V475.626H746.522V0Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_644_4520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.67 384.093C52.4677 379.942 49.1277 375.001 46.8422 369.554C44.5568 364.107 43.3709 358.262 43.3529 352.355C43.3348 346.448 44.485 340.595 46.7372 335.134C48.9894 329.674 52.2991 324.712 56.476 320.535",
    stroke: "#3561E4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.494 378.574C60.8115 375.268 57.8627 371.226 55.8378 366.71C53.8128 362.194 52.7566 357.304 52.7373 352.355C52.718 347.406 53.736 342.508 55.7256 337.976C57.7153 333.445 60.6324 329.38 64.289 326.045",
    stroke: "#3561E4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.242 372.857C70.8631 370.578 68.0954 367.504 66.182 363.906C64.2686 360.307 63.2679 356.294 63.2679 352.218C63.2679 348.142 64.2686 344.129 66.182 340.531C68.0954 336.932 70.8631 333.858 74.242 331.579",
    stroke: "#3561E4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.869 366.782C79.8514 365.683 77.2497 363.673 75.4238 361.031C73.5979 358.389 72.6379 355.244 72.6764 352.033C72.7149 348.821 73.7502 345.701 75.639 343.103C77.5277 340.506 80.1768 338.559 83.22 337.532",
    stroke: "#3561E4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.558 256.505C295.709 252.303 300.651 248.963 306.098 246.677C311.544 244.392 317.39 243.206 323.297 243.188C329.204 243.17 335.056 244.32 340.517 246.572C345.977 248.824 350.939 252.134 355.116 256.311",
    stroke: "#3561E4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.077 264.331C300.384 260.649 304.426 257.7 308.942 255.676C313.458 253.651 318.348 252.595 323.297 252.576C328.246 252.558 333.144 253.576 337.676 255.566C342.207 257.556 346.271 260.474 349.606 264.131",
    stroke: "#3561E4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.794 274.078C305.074 270.7 308.148 267.933 311.746 266.02C315.345 264.107 319.358 263.107 323.433 263.107C327.509 263.107 331.522 264.107 335.12 266.02C338.719 267.933 341.793 270.7 344.073 274.078",
    stroke: "#3561E4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.865 282.704C309.964 279.686 311.974 277.085 314.616 275.259C317.259 273.433 320.403 272.473 323.614 272.511C326.826 272.55 329.946 273.585 332.544 275.474C335.141 277.363 337.088 280.012 338.115 283.055",
    stroke: "#3561E4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.058 384.093C498.26 379.942 501.6 375.001 503.886 369.554C506.171 364.107 507.357 358.262 507.375 352.355C507.393 346.448 506.243 340.595 503.991 335.134C501.739 329.674 498.429 324.712 494.252 320.535",
    stroke: "#3561E4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.231 378.574C489.913 375.267 492.862 371.226 494.886 366.71C496.911 362.193 497.967 357.303 497.986 352.354C498.004 347.405 496.986 342.507 494.996 337.975C493.006 333.444 490.088 329.38 486.431 326.045",
    stroke: "#3561E4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.485 372.857C479.864 370.578 482.632 367.504 484.545 363.906C486.458 360.307 487.459 356.294 487.459 352.218C487.459 348.142 486.458 344.129 484.545 340.531C482.632 336.932 479.864 333.858 476.485 331.579",
    stroke: "#3561E4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.859 366.782C470.877 365.683 473.478 363.673 475.304 361.03C477.13 358.388 478.09 355.244 478.051 352.032C478.012 348.821 476.977 345.701 475.088 343.103C473.199 340.506 470.55 338.559 467.507 337.532",
    stroke: "#3561E4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_644_4520",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 129,
    y: 237,
    width: 352,
    height: 212
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M480.853 237.813H129.395V448.702H480.853V237.813Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_644_4520)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_644_4520",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 129,
    y: 237,
    width: 352,
    height: 212
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M480.853 237.813H129.395V448.702H480.853V237.813Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_644_4520)"
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M261.467 259.003L240.792 238.951H237.429C237.429 238.951 218 263.86 218.872 265.728C219.744 267.596 225.972 268.717 225.972 268.717L226.221 275.567L245.185 286.494L246.148 283.194L250.383 284.043C250.383 284.043 256.483 275.943 256.483 266.731C256.483 257.519 261.465 259.009 261.465 259.009",
    fill: "#1A2E35"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M249.42 251.466C249.046 251.342 239.298 238.079 238.92 237.83C238.542 237.581 225.469 239.947 217.62 251.779C209.771 263.611 213.261 267.223 214.631 267.472C216.001 267.721 245.394 268.472 247.636 266.849C249.878 265.226 249.413 251.465 249.413 251.465",
    fill: "#3561E4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M219.822 248.855C219.822 248.855 225.446 252.01 224.622 254.228C223.798 256.446 218.067 266.875 212.975 265.7C212.6 265.614 212.422 264.193 212.675 262.721C213.455 258.815 215.129 255.143 217.566 251.992L219.822 248.855Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_644_4520",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 223,
    y: 244,
    width: 25,
    height: 14
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M247.116 244.734H223.851V257.155H247.116V244.734Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_644_4520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.116 247.764C246.926 247.637 244.016 244.279 241.096 244.786C238.176 245.293 231.212 249.498 227.41 252.838C223.608 256.178 223.854 257.155 223.854 257.155C223.854 257.155 235.774 249.095 239.513 247.891C241.993 247.19 244.612 247.146 247.113 247.764",
    fill: "black"
  })))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M219.822 248.855C219.796 248.836 219.611 249.036 219.295 249.416C218.979 249.796 218.541 250.358 218.015 251.066C216.643 252.916 215.429 254.878 214.384 256.931C213.825 258.07 213.339 259.244 212.927 260.444C212.603 261.444 212.43 262.487 212.415 263.538C212.32 264.25 212.415 264.975 212.691 265.638C212.935 266.096 213.191 266.238 213.206 266.225C213.237 266.197 213.028 266.006 212.855 265.564C212.661 264.915 212.622 264.23 212.741 263.564C212.8 262.554 212.997 261.556 213.324 260.599C213.754 259.42 214.247 258.265 214.799 257.138C215.839 255.108 217.003 253.143 218.283 251.255C218.85 250.491 219.365 249.689 219.822 248.855Z",
    fill: "#1A2E35"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M431.99 343.646C431.99 343.646 451.397 381.509 460.597 387.846L459.166 390.708C459.166 390.708 458.366 391.321 446.294 381.308C434.222 371.295 427.679 359.42 421.959 355.751C419.119 353.841 416.108 352.198 412.964 350.845L431.99 343.646Z",
    fill: "#1A2E35"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M365.783 374.396H375.34L354.44 389.762L353.046 394.142L361.03 397.107L361.786 412.051C361.786 412.051 352.459 426.811 351.603 427.096C350.747 427.381 330.52 426.653 330.52 426.653L326.182 411.802L325.129 391.512C325.129 391.512 354.654 372.541 355.082 372.541C355.51 372.541 365.782 374.395 365.782 374.395",
    fill: "#1A2E35"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M361.139 405.787C361.139 413.886 363.541 421.804 368.041 428.539C372.54 435.273 378.936 440.522 386.419 443.622C393.902 446.721 402.136 447.532 410.08 445.952C418.024 444.372 425.321 440.472 431.048 434.745C436.775 429.018 440.676 421.721 442.256 413.777C443.836 405.833 443.025 397.599 439.926 390.116C436.827 382.633 431.578 376.237 424.843 371.737C418.109 367.237 410.192 364.835 402.092 364.835C396.714 364.835 391.389 365.894 386.42 367.952C381.451 370.01 376.937 373.026 373.134 376.829C369.331 380.632 366.315 385.146 364.256 390.115C362.198 395.084 361.139 400.409 361.139 405.787Z",
    fill: "#375A64"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M378.709 405.786C378.709 410.411 380.08 414.932 382.65 418.777C385.219 422.622 388.871 425.619 393.144 427.389C397.417 429.159 402.118 429.622 406.654 428.72C411.19 427.817 415.356 425.59 418.627 422.32C421.897 419.05 424.124 414.883 425.026 410.347C425.928 405.811 425.465 401.11 423.695 396.837C421.925 392.564 418.928 388.913 415.082 386.343C411.237 383.774 406.716 382.403 402.091 382.403C395.89 382.403 389.942 384.867 385.557 389.252C381.172 393.637 378.709 399.585 378.709 405.786Z",
    fill: "#E1E1E1"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M388.743 405.789C388.743 408.428 389.525 411.008 390.992 413.202C392.458 415.396 394.542 417.106 396.98 418.116C399.418 419.126 402.101 419.391 404.689 418.876C407.277 418.361 409.655 417.09 411.521 415.224C413.387 413.358 414.658 410.98 415.173 408.392C415.687 405.804 415.423 403.121 414.413 400.683C413.403 398.245 411.693 396.161 409.499 394.695C407.305 393.229 404.725 392.446 402.086 392.446C398.547 392.446 395.153 393.852 392.651 396.354C390.149 398.856 388.743 402.25 388.743 405.789Z",
    fill: "#1A2E35"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M425.064 363.128C423.594 361.143 422.7 372.387 420.122 374.966C417.544 377.545 408.985 375.173 397.773 377.115C379.892 380.215 374.641 389.842 370.457 394.707C369.956 395.282 369.303 395.704 368.573 395.923C367.843 396.143 367.066 396.151 366.331 395.947L352.431 392.158C352.431 392.158 360.812 371.528 384.02 364.652C407.228 357.776 425.064 363.128 425.064 363.128Z",
    fill: "#1A2E35"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M129.395 405.787C129.395 414.275 131.912 422.573 136.628 429.63C141.343 436.688 148.046 442.188 155.888 445.436C163.73 448.685 172.359 449.534 180.684 447.878C189.009 446.222 196.656 442.135 202.658 436.133C208.659 430.131 212.747 422.484 214.403 414.159C216.058 405.834 215.208 397.205 211.96 389.363C208.712 381.521 203.211 374.819 196.153 370.103C189.096 365.388 180.798 362.871 172.31 362.871C166.674 362.871 161.094 363.981 155.887 366.138C150.68 368.295 145.949 371.456 141.964 375.441C137.979 379.426 134.818 384.157 132.661 389.364C130.505 394.571 129.395 400.151 129.395 405.787Z",
    fill: "#375A64"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M147.807 405.787C147.807 410.633 149.244 415.37 151.936 419.399C154.628 423.428 158.454 426.568 162.931 428.422C167.408 430.276 172.334 430.762 177.087 429.816C181.839 428.871 186.205 426.538 189.631 423.111C193.058 419.685 195.391 415.319 196.336 410.567C197.282 405.814 196.796 400.888 194.942 396.411C193.088 391.935 189.947 388.108 185.918 385.416C181.889 382.724 177.153 381.287 172.307 381.287C165.809 381.287 159.578 383.868 154.983 388.463C150.388 393.058 147.807 399.289 147.807 405.787Z",
    fill: "#E1E1E1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M311.054 418.963C310.605 418.99 304.193 428.347 304.193 428.347H299.959V431.824C299.959 431.824 285.241 431.17 282.216 430.767C279.908 430.334 277.669 429.588 275.563 428.549C275.563 428.549 251.974 426.674 245.724 425.393C241.58 424.434 237.626 422.79 234.024 420.528C234.024 420.528 307.618 413.828 308.224 414.233C308.83 414.638 311.052 418.962 311.052 418.962",
    fill: "#1A2E35"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M246.112 287.285C245.771 289.334 233.82 316.99 233.82 316.99L242.697 322.79L227.332 349.422L236.722 390.053C236.722 390.053 262.501 390.394 286.743 382.541L302.446 353.524C300.063 347.14 298.458 340.492 297.666 333.724C297.666 333.724 291.52 332.017 290.837 327.578C290.154 323.139 294.937 316.652 294.937 316.652C294.937 316.652 317.472 306.752 368.346 302.312C368.346 302.312 400.1 296.512 402.146 296.849C404.192 297.186 407.609 304.249 407.609 304.249C407.609 304.249 435.609 304.359 438.338 314.602C438.338 314.602 441.07 322.114 409.657 337.137C378.244 352.16 343.418 365.476 343.418 365.476C343.418 365.476 340.686 379.133 335.565 382.206C330.444 385.279 278.204 402.692 259.083 401.668C239.962 400.644 234.158 397.912 222.549 390.401C210.94 382.89 197.965 360.355 194.21 352.501C190.455 344.647 207.185 336.795 217.428 324.501C227.671 312.207 241.328 283.187 241.328 283.187L246.112 287.285Z",
    fill: "#1A2E35"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask14_644_4520",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 178,
    y: 379,
    width: 39,
    height: 31
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M216.119 379.468H178.986V409.675H216.119V379.468Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_644_4520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.226 409.675C215.226 409.675 199.687 395.781 195.421 391.804C191.155 387.827 190.821 386.677 190.821 386.677L180.947 396.228L178.986 393.497L192.674 379.468L216.119 402.611L215.226 408.689",
    fill: "black"
  })))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M174.392 349.823C174.392 349.823 152.927 352.889 142.092 365.769C131.257 378.649 134.324 379.875 134.324 379.875C134.324 379.875 150.474 375.582 160.082 379.875C169.69 384.168 169.482 392.141 169.482 392.141L177.666 396.223L193.678 378.233L180.321 349.823H174.392Z",
    fill: "#3561E4"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask15_644_4520",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 169,
    y: 349,
    width: 24,
    height: 35
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M192.674 349.054H169.221V383.258H192.674V349.054Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_644_4520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.186 383.254C189.186 383.254 185.015 375.781 181.077 369.409C176.752 362.409 169.221 350.889 169.221 350.889L175.482 349.05L192.674 379.464L189.186 383.254Z",
    fill: "black"
  })))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M223.456 272.956C222.025 272.956 215.279 276.022 207.306 284.2C199.333 292.378 157.629 339.806 157.425 343.69C157.418 343.829 157.414 343.965 157.415 344.1C157.452 345.641 158.095 347.105 159.203 348.176C160.311 349.247 161.797 349.839 163.338 349.823H170.509L175.824 353.503C175.824 353.503 188.908 383.888 212.213 401.711C214.399 404.005 216.194 406.642 217.528 409.517C219.368 413.81 221.208 419.125 223.457 420.148C225.706 421.171 323.833 420.348 325.057 417.081C326.694 412.649 327.859 408.057 328.532 403.381C328.941 399.292 338.14 389.071 348.975 384.164C359.81 379.257 435.86 344.1 436.883 340.01C437.906 335.92 443.209 319.777 437.899 313.437C432.589 307.097 350.236 346.759 331.399 364.137L307.48 386.216C307.48 386.216 263.732 393.985 262.096 394.393C260.46 394.801 230.205 393.576 230.205 393.576L218.14 369.243L209.554 350.027L230.815 315.478C230.815 315.478 243.194 283.189 242.263 283.189C241.332 283.189 223.455 272.956 223.455 272.956",
    fill: "#3561E4"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M432.109 379.558L442.481 401.71L381.281 427.097L372.695 406.45L432.109 379.558Z",
    fill: "#1A2E35"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M445.454 382.603L434.901 385.521L439.235 394.779L447.774 392.467L445.454 382.603Z",
    fill: "#1A2E35"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M375.553 413.33L345.399 425.275H318.723V418.923H313.153V429.574H326.637V431.821H344.909L378.316 419.978L375.553 413.33Z",
    fill: "#1A2E35"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M437.831 336.504C437.786 336.674 427.298 342.559 422.998 342.822C418.698 343.085 417.03 340.277 416.065 338.171C415.287 336.31 414.613 334.407 414.047 332.471C414.047 332.471 438.147 313.694 438.402 314.114C440.158 317.014 440.357 317.935 440.355 323.869C440.355 326.343 437.971 336.488 437.831 336.508",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask16_644_4520",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 287,
    y: 387,
    width: 56,
    height: 31
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M342.618 387.73H287.212V417.502H342.618V387.73Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_644_4520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.614 387.736C343.084 387.347 298.246 403.787 294.621 404.89C290.996 405.993 287.212 417.501 287.212 417.501C287.212 417.501 291.626 408.831 297.301 406.624C302.976 404.417 334.962 394.07 342.615 387.736",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask17_644_4520",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 180,
    y: 302,
    width: 52,
    height: 34
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M231.662 302.126H180.088V335.184H231.662V302.126Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_644_4520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.116 315.728L180.088 335.184C180.088 335.184 186.388 324.23 203.998 315.942C214.422 311.035 231.662 302.126 231.662 302.126L230.828 303.586C227.861 308.783 223.444 313.002 218.116 315.728Z",
    fill: "black"
  })))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M297.674 333.72C297.773 333.752 297.875 333.774 297.979 333.786L298.879 333.932L302.358 334.442C305.382 334.87 309.758 335.467 315.179 336.148C320.6 336.829 327.054 337.606 334.247 338.27C336.047 338.427 337.89 338.596 339.78 338.703C340.724 338.769 341.68 338.82 342.646 338.845C343.63 338.913 344.619 338.875 345.595 338.731C349.595 337.941 353.488 336.685 357.195 334.987C364.87 331.694 371.895 327.957 378.228 324.492C384.555 321.006 390.166 317.715 394.843 314.892C397.181 313.48 399.285 312.185 401.121 311.03C402.723 310.078 404.219 308.959 405.586 307.692C406.496 306.919 407.15 305.888 407.462 304.736C407.522 304.535 407.535 304.323 407.5 304.116C407.466 303.909 407.384 303.713 407.262 303.542C407.439 303.908 407.478 304.326 407.372 304.719C407.028 305.833 406.363 306.822 405.462 307.562C404.085 308.794 402.584 309.882 400.985 310.809C399.137 311.943 397.023 313.218 394.676 314.609C389.976 317.392 384.356 320.652 378.024 324.109C371.684 327.549 364.663 331.271 357.016 334.552C353.346 336.233 349.493 337.482 345.535 338.273C344.584 338.415 343.621 338.453 342.662 338.388C341.702 338.365 340.751 338.317 339.809 338.253C337.926 338.153 336.084 337.987 334.287 337.836C327.101 337.196 320.642 336.449 315.221 335.814L302.384 334.254L298.893 333.83L297.984 333.73C297.881 333.713 297.776 333.707 297.672 333.711",
    fill: "#375A64"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M294.918 324.908C295.006 324.951 295.099 324.985 295.195 325.008L296.022 325.261C296.75 325.478 297.822 325.813 299.234 326.12C303.211 327.043 307.267 327.588 311.347 327.748C312.637 327.836 313.992 327.803 315.402 327.829C316.812 327.783 318.281 327.777 319.796 327.66C323.025 327.465 326.241 327.101 329.432 326.568C336.736 325.315 343.93 323.489 350.948 321.108C358.435 318.643 365.431 315.926 371.809 313.516C378.181 311.081 383.951 309 388.841 307.348C391.05 306.611 393.197 305.7 395.263 304.624C396.831 303.813 398.273 302.779 399.544 301.554C400.335 300.769 401.023 299.885 401.589 298.925L401.975 298.149C402.023 298.063 402.063 297.972 402.092 297.878C401.392 299.193 400.49 300.39 399.419 301.425C398.141 302.612 396.701 303.612 395.142 304.396C393.077 305.44 390.935 306.324 388.735 307.039C383.835 308.649 378.035 310.705 371.66 313.117C365.271 315.506 358.275 318.209 350.804 320.669C343.808 323.042 336.641 324.874 329.364 326.148C326.188 326.689 322.987 327.067 319.772 327.278C318.264 327.403 316.802 327.418 315.398 327.478C313.998 327.461 312.644 327.504 311.36 327.427C307.295 327.296 303.251 326.802 299.274 325.951C297.86 325.671 296.784 325.365 296.048 325.178L295.21 324.969C295.116 324.94 295.018 324.921 294.92 324.913",
    fill: "#375A64"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M345.718 338.854C345.567 338.89 345.421 338.946 345.285 339.021L344.085 339.58C343.047 340.069 341.546 340.78 339.664 341.598C335.914 343.263 330.652 345.379 324.742 347.446C318.832 349.513 313.389 351.116 309.416 352.146C307.434 352.675 305.816 353.051 304.699 353.314L303.413 353.621C303.26 353.647 303.111 353.693 302.97 353.759C303.125 353.764 303.28 353.749 303.431 353.713L304.736 353.491C305.866 353.283 307.499 352.954 309.496 352.465C313.496 351.517 318.965 349.948 324.896 347.888C330.827 345.828 336.076 343.646 339.796 341.901C341.664 341.043 343.148 340.285 344.162 339.746L345.323 339.108C345.463 339.042 345.595 338.958 345.713 338.858",
    fill: "#375A64"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M305.434 384.917C305.515 384.816 305.588 384.708 305.652 384.595L306.252 383.626L308.524 379.882C310.509 376.64 313.355 371.924 317.273 366.374C319.401 363.344 321.687 360.428 324.119 357.637C326.901 354.428 329.959 351.47 333.258 348.796C336.92 345.863 340.874 343.315 345.058 341.191C349.555 338.915 354.189 336.92 358.934 335.219C375.602 329.222 392.71 324.525 410.104 321.171C416.78 319.887 422.216 319.031 425.978 318.484L430.312 317.861L431.438 317.692C431.567 317.678 431.695 317.654 431.82 317.619C431.69 317.617 431.56 317.626 431.432 317.645L430.3 317.768C429.306 317.887 427.837 318.042 425.953 318.306C422.181 318.799 416.733 319.606 410.043 320.85C392.607 324.114 375.463 328.774 358.774 334.785C354.011 336.492 349.361 338.495 344.849 340.785C340.642 342.928 336.668 345.5 332.99 348.461C329.679 351.158 326.614 354.143 323.83 357.381C321.401 360.191 319.123 363.129 317.006 366.181C313.113 371.769 310.306 376.514 308.37 379.781L306.17 383.57L305.611 384.563C305.543 384.673 305.484 384.789 305.434 384.909",
    fill: "#375A64"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M158.328 405.787C158.328 408.553 159.148 411.256 160.685 413.556C162.221 415.855 164.405 417.647 166.96 418.706C169.515 419.764 172.327 420.041 175.039 419.501C177.751 418.962 180.243 417.63 182.198 415.674C184.154 413.719 185.486 411.227 186.025 408.515C186.565 405.802 186.288 402.991 185.23 400.436C184.171 397.881 182.379 395.697 180.08 394.161C177.78 392.624 175.077 391.804 172.311 391.804C168.602 391.804 165.046 393.277 162.424 395.899C159.801 398.522 158.328 402.078 158.328 405.787Z",
    fill: "#1A2E35"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M180.362 334.905C180.515 334.762 180.654 334.604 180.776 334.434C181.04 334.12 181.399 333.634 181.902 333.034C183.289 331.332 184.765 329.705 186.324 328.16C188.638 325.873 191.144 323.789 193.816 321.933C197.099 319.674 200.563 317.692 204.173 316.006C211.881 312.406 218.749 308.914 223.701 306.36L229.549 303.3L231.127 302.446C231.316 302.355 231.496 302.246 231.663 302.12C231.463 302.182 231.269 302.263 231.085 302.363L229.467 303.14L223.553 306.069C218.563 308.549 211.68 311.991 203.975 315.589C200.343 317.287 196.863 319.294 193.575 321.589C190.896 323.474 188.393 325.598 186.096 327.934C184.549 329.506 183.102 331.174 181.764 332.927C181.282 333.541 180.946 334.046 180.705 334.378C180.575 334.542 180.461 334.718 180.366 334.905",
    fill: "#1A2E35"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M197.382 327.036C197.632 327.037 197.877 327.109 198.088 327.242C198.299 327.376 198.469 327.566 198.577 327.792C198.685 328.017 198.728 328.268 198.7 328.517C198.672 328.765 198.575 329.001 198.42 329.197C194.797 333.578 190 336.834 184.591 338.583C173.604 342.342 171.915 340.406 173.072 339.25C174.133 338.189 188.289 326.93 197.382 327.036Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M437.702 336.984C437.84 336.705 437.94 336.408 438.002 336.103C438.166 335.529 438.388 334.695 438.653 333.663C439.398 330.983 439.98 328.259 440.394 325.508C440.623 323.984 440.718 322.442 440.68 320.901C440.635 319.635 440.414 318.382 440.025 317.176C439.761 316.365 439.391 315.591 438.925 314.876C438.771 314.603 438.571 314.359 438.335 314.153C438.901 315.142 439.362 316.188 439.711 317.273C440.045 318.459 440.227 319.683 440.252 320.915C440.265 322.431 440.158 323.946 439.934 325.445C439.513 328.653 438.768 331.506 438.334 333.592C438.11 334.633 437.934 335.478 437.827 336.064C437.746 336.364 437.704 336.673 437.703 336.984",
    fill: "#1A2E35"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask18_644_4520",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 347,
    y: 338,
    width: 60,
    height: 33
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M406.449 338.66H347.382V370.161H406.449V338.66Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_644_4520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.448 338.66L347.384 369.981C347.384 369.981 347.084 370.796 352.431 368.962C357.778 367.128 398.892 346.456 406.448 338.662",
    fill: "black"
  })))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M480.854 306.721L476.849 311.076H427.2C427.2 311.076 418.325 305.746 417.775 305.737L480.853 306.721",
    fill: "#1A2E35"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferRealtime);
export default __webpack_public_path__ + "static/media/offer_realtime.c4ff6918cf6e8871418adb6c24fa518a.svg";
export { ForwardRef as ReactComponent };